import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { DataService } from '../data.service';
import { HttpClient } from '@angular/common/http';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, firstValueFrom, fromEvent, Subscription, take } from 'rxjs';
import { AlertController, IonModal, ModalController } from '@ionic/angular';
import { TanarComponent } from '../components/tanar/tanar.component';
import { TanteremComponent } from '../components/tanterem/tanterem.component';
import { TantargyComponent } from '../components/tantargy/tantargy.component';
import { OsztalyComponent } from '../components/osztaly/osztaly.component';
import { Calendar, CalendarOptions, EventClickArg } from '@fullcalendar/core'; // useful for typechecking
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid'
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import { FullCalendarComponent } from '@fullcalendar/angular';
import moment from 'moment';
import 'moment/locale/hu'
import { environment } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from '../auth.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { tomegesErtekeles, uresekSzama } from '../ertekeles-tomeges';
import { NkpBeillesztesComponent } from './nkp-beillesztes/nkp-beillesztes.component';
import { sajatTetelE, jegyModositasBekeres, NEGYEDEV_JEL, NEGYEDEV_NEV, negyedevesE, NEM_IRTA_JEL, nemIrtaE, nemIrtaJelE, nemIrtaModE, strukturaltRovid, stornoE, stornoOkBekeres, NAPLO_MUVELET } from '../ertekeles-modositas';

@Component({
  selector: 'app-ertekelesek',
  templateUrl: './ertekelesek.component.html',
  styleUrls: ['./ertekelesek.component.scss'],
})
export class ErtekelesekComponent implements OnInit, AfterViewInit {
  correctCards: number = 0;
  success: boolean = false;
  cards = []; // Cards to drag
  slots = []; // Slots to drop into
  isSlotFilled: boolean[][] = []; // Track which slots are filled
  cardInSlot = []; // Store the card in the slot
  latottHet = [];
  calendarready = false;
  calapi?: Calendar
  orarendmode = "osztaly"
  kivosztaly = null
  // A képernyőn megjelenített tanév (fejléc-választó) és az intézmény aktuális tanéve.
  // Ha a kettő eltér, korábbi/előkészített évet nézünk – írni ilyenkor nem szabad.
  megjelenitettTanev: number | null = null
  aktualisTanev: number | null = null
  kivtanar = null
  kivterem = null
  kivtantargy = null
  /*  A TANTÁRGY-VÁLASZTÓ TARTALMA. Nem az iskola összes tantárgya: a kiválasztott osztályban
   *  vagy csoportban az órarend szerint tanított tárgyak (a kiszolgáló adja, `tantargyak`).
   *  A hasonló nevű változatok közül a rosszat választva a jegy a napló óránál nem látszott
   *  (EU2K: 98 jegy), a több tantárgyas csoportnál pedig könnyű volt másik tárgyhoz írni.
   *  Az „összes tantárgy” kapcsolóval ki lehet lépni belőle. */
  kivEgyseg: any = null
  mindenTantargy = false
  tantargyValasztek: any[] = []

  /*  OSZTÁLYHOZ/CSOPORTHOZ KÖTÖTT TANTÁRGYAK (2026-10-19, a user: „vegyük ki a csoport/osztály
   *  nélküli tárgyakat”). A kiszolgáló (tanitott.js › egysegben_tantargyak) adja: amit a tanévben
   *  órarend vagy tantárgyfelosztás szerint legalább egy osztály vagy csoport tanul. Ebből
   *  választ az értékelés, a mulasztás, a feljegyzés és a számonkérés is; a teljes `tantargy`
   *  lista a nevek feloldására marad. A magatartás/szorgalom nem órarendi, mindig benne van.
   *  Ha a kiszolgáló üres listát ad (még nincs órarend és felosztás), nem szűrünk. */
  egysegbenTantargyIdk: string[] = []
  get tantargyEgysegben(): any[] {
    const lista = this.tantargy || [];
    if (!this.egysegbenTantargyIdk.length) return lista;
    const ids = new Set(this.egysegbenTantargyIdk);
    return lista.filter((t: any) => ids.has(String(t.id)) || this.orarendFuggetlenTantargy(t.id));
  }
  tantargyEgysegbenLista: any[] = []

  tantargyValasztekFrissit() {
    this.tantargyEgysegbenLista = this.tantargyEgysegben;
    const lista = this.tantargyEgysegbenLista;
    const ids = ((this.kivEgyseg?.tantargyak || []) as any[]).map(String);
    this.tantargyValasztek = (this.mindenTantargy || !ids.length)
      ? lista
      : lista.filter((t: any) => ids.includes(String(t.id)) || String(t.id) === String(this.kivtantargy ?? '')
          || this.orarendFuggetlenTantargy(t.id));
  }

  /*  A MAGATARTÁS ÉS A SZORGALOM nem órarendi tárgy: egyik osztálynak sincs ilyen órája,
   *  mégis minden osztályban értékelni kell. Az órarend szerinti szűrés ezért nem érinti –
   *  különben osztályválasztáskor kiesett a választott tárgy (Zenit, 4.z, 2026-10-12). */
  orarendFuggetlenTantargy(id: any): boolean {
    const t = (this.tantargy || []).find((x: any) => String(x.id) === String(id ?? ''));
    const n = String((t as any)?.name || (t as any)?.nev || '').toLowerCase();
    return !!n && (n.includes('magatart') || n.includes('szorgalom'));
  }

  get tantargySzukitve(): boolean {
    return !!(this.kivEgyseg?.tantargyak?.length);
  }

  mindenTantargyValt() {
    this.mindenTantargy = !this.mindenTantargy;
    this.tantargyValasztekFrissit();
  }
  selectedUser
  tankezd
  tanvege
  tanfelev
  blokk = []
  allomanyKi = []
  allomanyBe = []

  @ViewChild(FullCalendarComponent, { static: false }) cal!: FullCalendarComponent;
  @ViewChild("orarendmodal") orarendmodal: IonModal;
  @ViewChild("helyettesitesmodal") helyettesitesmodal: IonModal;
  @ViewChild("feljegyzesModal") feljegyzesModal: IonModal;
  /*set cal(cmp: FullCalendarComponent | undefined) {
  if (!cmp) return;                    // not yet in view / got destroyed
  this.calapi = cmp.getApi();            // <-- NOW it's safe
  this.onCalendarReady();
}*/

  allomany = [];
  orarend = [];
  csengetes = [];
  osztaly = [];
  tantargy = [];
  terem = [];
  ttf = [];
  filled = [];
  elhasznalt = [];
  sajatIntezmeny;
  mostdrag

  title = 'context-menu';
  isDisplayContextMenu: boolean;
  rightClickMenuItems: Array<any> = [];
  rightClickMenuPositionX: number;
  rightClickMenuPositionY: number;
  protected readonly JSON = JSON;
  protected readonly environment = environment;

  @ViewChild('userMenu') userMenu: TemplateRef<any>;
  overlayRef: OverlayRef | null;
  sub: Subscription;
  @ViewChild(IonModal) modal: IonModal;
  kivalasztottora
  nezet = 1
  het = 0
  napok = ["Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat", "Vasárnap"]
  hetek = ["A", "B", "C", "D", "E", "F", "G"]
  formo: FormGroup;
  formh: FormGroup;
  oraevent
  orameta
  orarenduzemmod = "helyettesites"

  kivalasztottOra
  ertekelesTipus
  uzemmod
  /*  A választható osztályok ÉS csoportok – a kiszolgálótól, a kilét szerint szűrve.
      Pedagógusnál csak amit tanít, adminnál minden (a sajátjai elöl). */
  /** A választó összetett értéke: `o:<osztalyId>` vagy `c:<csoportId>`. */
  kivosztalyErtek: string | null = null;
  kivcsoport: string | null = null;
  csoportTanulok: string[] = [];
  tanitottAdmin = false;
  /*  A csak helyettesítés miatt látható csoportok alapból rejtve: egy egyszeri
   *  helyettesítéstől a csoport nem lesz a kolléga sajátja. Pipával bekapcsolható. */
  tanitottLista: any[] = [];
  helyettesitettMutat = false;
  helyettesitettDb = 0;
  kivdatum
  kivdatummin
  kivdatummax
  kivtanulo
  mulasztas_tipus
  feljegyzesTipusok: any[] = [];
  private readonly alapFeljegyzesTipusok = [
    { nev: 'Na' },
    { nev: 'Dicséret' },
    { nev: 'Igazgatói dicséret' },
    { nev: 'Osztályfőnöki dicséret' },
    { nev: 'Szaktanári dicséret' },
    { nev: 'Igazgatói intő' },
    { nev: 'Osztályfőnöki intő' },
    { nev: 'Szaktanári intő' },
    { nev: 'Igazgatói figyelmeztető' },
    { nev: 'Osztályfőnöki figyelmeztető' },
    { nev: 'Szaktanári figyelmeztető' },
    { nev: 'Felszereléshiány' },
    { nev: 'Házi feladat hiány' },
  ];
  feljegyzesForm: any = {
    id: null,          // meglévő feljegyzés módosításakor az azonosítója
    tanulo_id: null,
    tanulo_oktazon: null,
    datum: moment().format('YYYY-MM-DD'),
    tipus: null,
    szoveg: '',
    adatok: {}         // a mezős típus (pl. korlátozott tárgy engedélye) kitöltött mezői
  };
  /*  A típusok TELJES listája (a csak admin típusokkal együtt) – ebből tudjuk, mely meglévő
   *  bejegyzést módosíthat vagy törölhet a pedagógus. A választóba (`feljegyzesTipusok`) csak
   *  a neki engedett típusok kerülnek. */
  private feljegyzesTipusokOsszes: any[] = [];
  aktivFeljegyzesTanulo: any = null;
  sztanulok
  /** Tanulói belépésnél a saját sor – ilyenkor a tanuló neve rögzített. */
  sajatSor: any = null
  intezmenyTanulok: any[] = []
  user$
  kivtantargyNev = null
  /** 2 félévi, 3 év végi, 4 I., 6 II., 5 III., 7 IV. negyedéves. */
  zaroTipus: '2' | '3' | '4' | '5' | '6' | '7' = '2'
  zaroFormak: string[] = ['szoveges'] // a kiválasztott osztály évfolyamára engedélyezett formák
  /** Az 5D a dicséretes ötös: az érték 5, a jelölő külön mentődik. */
  readonly zaroJegyOpciok: (number | string)[] = [1, 2, 3, 4, 5, '5D'];
  readonly zaroFormaCimke: Record<string, string> = {
    szoveges: 'Szöveges',
    szazalek: 'Százalék',
    jegy: 'Érdemjegy',
  };
  zaroJegyekModalOpen = false
  zaroJegyekTanulo: any = null
  zaroMondatbankModalOpen = false
  zaroMondatbankTanulo: any = null
  zaroMondatbank: any[] = []
  zaroMondatbankKereses = ''
  zaroMondatbankLoading = false
  private zaroTextareaCursor: Record<string, { start: number; end: number }> = {}
  szamonkeresek: any[] = []
  /*  ELŐZMÉNY-ABLAK (storno + napló, 2026-10-15): egy tétel naplója időrendben – ki írta be,
   *  ki módosította és mit, ki stornózta és miért. `null`: zárva. */
  elozmeny: { cim: string; sorok: any[]; betolt: boolean; hiba?: string } | null = null
  szamonkeresForm = {
    id: null,
    datum: moment().format('YYYY-MM-DD'),
    tipus: null,
    cim: '',
    leiras: ''
  }
  szamonkeresMentFolyamatban = false

  mk
  mv
  readonly zaroElsoFelevHonapok = ['09', '10', '11', '12', '01/I'];
  readonly zaroMasodikFelevHonapok = ['01/II', '02', '03', '04', '05', '06'];

  readonly FOKOZATOK = ['Példás', 'Jó', 'Változó', 'Hanyag'];
  readonly FOKOZAT_GOMBOK = [
    { rovid: 'P', ertek: 'Példás' },
    { rovid: 'J', ertek: 'Jó' },
    { rovid: 'V', ertek: 'Változó' },
    { rovid: 'H', ertek: 'Hanyag' },
  ];

  /*  JEGYBEÍRÁS GOMBOKKAL.
   *
   *  Az érdemjegy öt értéket vehet fel, mégis szabad szövegmező volt hozzá: a tanár
   *  gépelt, mobilon számbillentyűzet nyílt, és egy félreütésből 55 lett. Egy koppintás
   *  ugyanazt elintézi – ahogy a mellette álló „–" (nem írta meg) gomb is.
   *
   *  A százalékos (mód 2) és a fokozatos (mód 4) értékelés NEM érintett: ott a gombsor
   *  nem segítene, azoknak megvan a saját beviteli módjuk. A kapcsoló az 1–5 jegyre hat.
   */
  readonly JEGY_GOMBOK = ['1', '2', '3', '4', '5'];
  //  Az alapérték a gombos mód; a kiszolgáló válasza írja felül, ha az iskola kikapcsolta.
  jegyGombok = true;

  /** Ezt a jegyet mutatja-e a cella (a gomb kitöltött állapotához). */
  jegyEgyezik(ertek: any, gomb: string): boolean {
    return String(ertek ?? '').trim() === String(gomb);
  }

  /*  Ugyanarra a gombra újra koppintva TÖRÖL. Enélkül a tévesen megnyomott jegyet
   *  csak a sor újratöltésével lehetne visszavonni – gombsornál nincs hova „kitörölni". */
  jegyGombra(sor: any, gomb: string) {
    if (!sor) return;
    sor.osztalyzat = this.jegyEgyezik(sor.osztalyzat, gomb) ? '' : String(gomb);
  }

  /** Gombsorral írjuk-e a jegyet ennél az óránál? */
  jegyGombosMod(ora: any): boolean {
    return this.jegyGombok && String(ora?.osztalyozasimod ?? '') !== '2';
  }
  /*  A BEÁLLÍTÁST A KISZOLGÁLÓTÓL KÉRDEZZÜK, nem a belépéskor eltárolt intézmény-adatból:
   *  az adminban most átállított érték azonnal éljen, ne csak ki- és belépés után.
   *  Ha nem jön válasz, marad a gombos mód – az az alapértelmezés. */
  private jegyBeallitasBetolt(http: any, intezmenyId: any) {
    const ut = String(intezmenyId || '').replace(/^\/+|\/+$/g, '');
    if (!ut) return;
    http.get(`/api/ertekeles/beallitas/${ut}`).subscribe({
      next: (v: any) => { this.jegyGombok = v?.jegy_gombok !== false; },
      error: () => { /* marad az alapértelmezés */ },
    });
  }


  formatErtekelesRovid(ertekeles: any): string {
    const value = String(ertekeles ?? '').trim();
    const fokozatMap: Record<string, string> = {
      'Példás': 'P',
      'Jó': 'J',
      'Változó': 'V',
      'Rossz': 'H',
      'Hanyag': 'H',
      'R': 'H',
    };

    // A '/' csak a magatartás/szorgalom formátumnál jelent kettéosztást (pl.
    // "Példás / Jó"), ahol minden rész rövid fokozat. Egy '/' jelet TARTALMAZÓ
    // szöveges értékelést NEM szabad így kezelni – az lentebb 'SZ' lesz.
    if (value.includes('/')) {
      const reszek = value.split('/').map((resz) => resz.trim());
      const csakFokozat = reszek.every((resz) => !!fokozatMap[resz] || resz.length <= 4);
      if (csakFokozat) {
        return reszek.map((resz) => fokozatMap[resz] || resz).join(' / ');
      }
    }

    if (fokozatMap[value]) return fokozatMap[value];
    //  Szám (pl. NKP-eredmény „48.5%”) sosem „SZ”: az a hosszú szöveges értékelés rövidítése.
    if (/^-?\d+([.,]\d+)?\s*%?$/.test(value)) return value.replace(/^(-?\d+)[.,]\d+/, '$1').replace(/\s+/g, '');
    if (value.length > 4) return 'SZ';
    return value;
  }

  getSpecialErtekelesReszletek(ertekeles: any): { magatartas: string; szorgalom: string } | null {
    const value = String(ertekeles ?? '').trim();
    if (!value.includes('/')) return null;

    const [magatartasRaw, szorgalomRaw] = value.split('/').map((resz) => resz.trim());
    return {
      magatartas: this.formatErtekelesRovid(magatartasRaw),
      szorgalom: this.formatErtekelesRovid(szorgalomRaw),
    };
  }

  isMagatartasSzorgalomTantargy(): boolean {
    if (!this.kivtantargy || !this.tantargy) return false;
    const t = this.tantargy.find((t: any) => t.id === this.kivtantargy);
    if (!t) return false;
    const n = ((t as any).name || (t as any).nev || '').toLowerCase();
    return n.includes('magatart') && n.includes('szorgalom');
  }

  isFokozatTantargy(): boolean {
    if (!this.kivtantargy || !this.tantargy) return false;
    const t = this.tantargy.find((t: any) => t.id === this.kivtantargy);
    if (!t) return false;
    const n = ((t as any).name || (t as any).nev || '').toLowerCase();
    return n.includes('magatart') || n.includes('szorgalom');
  }

  /**
   *  A VÁLASZTOTT OSZTÁLYOZÁSI MÓD MEGMARAD.
   *
   *  A névsor minden mentés (és minden jegytörlés) után újratöltődik, és eddig
   *  ilyenkor a mód visszaugrott „Osztályzat (1-5)"-re — akkor is, ha a tanár épp
   *  SZÁZALÉKOT írt be. A következő adag így csendben érdemjegyként ment el: a 85-ből
   *  nem 85%, hanem a 85-ös „jegy" lett. A típus és a téma megmarad az újratöltés
   *  után, a módnak sincs oka elveszni.
   *
   *  Tantárgyváltáskor viszont a TANTÁRGY alapértéke jön (a magatartás/szorgalom
   *  fokozatos), ezért ott a `kivalaszt()` szándékosan törli az emlékezett módot.
   */
  private valasztottOsztalyozasiMod(): string {
    if (this.isFokozatTantargy()) return '4';
    const elozo = String(this.kivalasztottOra?.osztalyozasimod ?? '');
    return ['1', '2', '3', '4'].includes(elozo) ? elozo : '1';
  }

  /**
   *  AZ OSZTÁLYOZÁSI MÓD ZÁROLÁSA.
   *
   *  Ha a betöltött tantárgy + osztály/csoport évközi jegyei már EGYFÉLE formában vannak
   *  (osztályzat, százalék, fokozat, szöveges), az új jegy is csak abban írható be:
   *  egy érdemjegyek közé került „85%” az átlagot és a KRÉTA-átadást is elrontja. A
   *  választó ilyenkor a meglévő módra áll és nem változtatható; váltani a jegyek
   *  törlése után lehet. (A kiszolgáló a mentésnél ugyanezt ellenőrzi.)
   */
  osztalyozasiModZar: { mod: string; nev: string } | null = null;

  private static readonly FORMA_MOD: Record<string, string> = { erdemjegy: '1', szazalek: '2', szoveges: '3', fokozat: '4' };
  private static readonly MOD_NEV: Record<string, string> = {
    '1': 'Osztályzat (1-5)', '2': 'Százalék', '3': 'Szöveg', '4': 'Fokozat',
  };

  private jegyForma(item: any): string | null {
    const tarolt = String(item?.ertek_forma ?? '').trim();
    if (tarolt) return tarolt;
    //  Régi (forma nélküli) sor: az értékből következtetünk.
    const e = String(item?.ertekeles ?? '').trim().toLowerCase();
    if (!e) return null;
    if (e.endsWith('%')) return 'szazalek';
    if (/^[1-5]([/.,-][1-5])?[+-]?$/.test(e)) return 'erdemjegy';
    if (/^(példás|jó|változó|hanyag|rossz)$/.test(e)) return 'fokozat';
    return null;
  }

  private osztalyozasiModZarSzamol() {
    this.osztalyozasiModZar = null;
    const adat = this.kivalasztottOra?.ertekelesek;
    if (!adat || typeof adat !== 'object') return;
    const formak = new Set<string>();
    for (const tanulo of Object.values(adat) as any[]) {
      for (const lista of Object.values(tanulo?.months || {}) as any[]) {
        for (const item of (Array.isArray(lista) ? lista : [])) {
          if (stornoE(item)) continue;   // a stornózott jegy nem köti a formát
          const f = this.jegyForma(item);
          if (f && ErtekelesekComponent.FORMA_MOD[f]) formak.add(f);
        }
      }
    }
    if (formak.size !== 1) return;
    const mod = ErtekelesekComponent.FORMA_MOD[[...formak][0]];
    this.kivalasztottOra.osztalyozasimod = mod;
    this.osztalyozasiModZar = { mod, nev: ErtekelesekComponent.MOD_NEV[mod] };
  }

  applySpecialErtekelesDefaults() {
    if (!this.kivalasztottOra) return;
    if (!this.isMagatartasSzorgalomTantargy()) return;

    this.kivalasztottOra.osztalyozasimod = '4';

    const beszamoloId = this.getBeszamoloTipusId();
    if (beszamoloId) {
      this.kivalasztottOra.szam_tipus = beszamoloId;
    }

    this.ensureSpecialTanuloFields();
  }

  isTechnikaiErtekelesTipus(tipus: any): boolean {
    const nev = String(tipus?.nev ?? tipus?.name ?? '').trim();
    return nev === '-';
  }

  /**
   *  A választóban felkínált típusok. Az adminban ELREJTETT típus nem választható többé –
   *  kivéve, ha egy meglévő bejegyzésnél épp az van kiválasztva: különben a választó üresen
   *  mutatná, és egy mentés csendben átírná a típusát.
   */
  valaszthatoTipusok(kivalasztott: any): any[] {
    return (this.ertekelesTipus || []).filter((t: any) =>
      !Number(t?.rejtett) || String(t?.id) === String(kivalasztott ?? ''));
  }

  getBeszamoloTipusId(): string | null {
    return '20';
  }

  ensureSpecialTanuloFields() {
    if (!this.isMagatartasSzorgalomTantargy() || !this.kivalasztottOra?.osztaly_nevsor) return;

    this.kivalasztottOra.osztaly_nevsor = this.kivalasztottOra.osztaly_nevsor.map((tanulo: any) => ({
      ...tanulo,
      osztalyzat: tanulo?.osztalyzat ?? '',
      szorgalomodost: tanulo?.szorgalomodost ?? '',
    }));
  }

  isDualFokozatMode(): boolean {
    return this.isMagatartasSzorgalomTantargy() && this.kivalasztottOra?.osztalyozasimod === '4';
  }

  getCombinedDualFokozat(tanulo: any): string {
    const magatartas = this.formatErtekelesRovid(tanulo?.osztalyzat || '').trim();
    const szorgalom = this.formatErtekelesRovid(tanulo?.szorgalomodost || '').trim();

    if (magatartas && szorgalom) return `${magatartas} / ${szorgalom}`;
    return magatartas || szorgalom || '';
  }

  /** Az osztály/csoport választó tartalma a „Helyettesített csoportok” pipa szerint. */
  osztalyValasztekFrissit() {
    const csakHelyettes = (o: any) => !!o?.helyettesitett && !o?.sajat;
    this.helyettesitettDb = this.tanitottAdmin ? 0 : this.tanitottLista.filter(csakHelyettes).length;
    this.osztaly = (this.tanitottAdmin || this.helyettesitettMutat)
      ? this.tanitottLista
      : this.tanitottLista.filter((o: any) => !csakHelyettes(o));
  }

  private filterVisibleOsztalyok(osztalyok: any[]): any[] {
    return (osztalyok || []).filter((o: any) => {
      /*  A CSOPORTOT sosem rejtjük el: a „0z" kizárás az ÓVODAI előkészítő osztályra
       *  szól, egy csoport neve viszont véletlenül is kezdődhet ugyanígy. */
      if (o?.tipus === 'csoport') return true;
      const nev = String(o?.osztaly || o?.nev || o?.name || '').trim().toLowerCase();
      return nev !== '0z' && nev !== '0.z.' && nev !== '0. z.' && nev !== '0. z';
    });
  }

  private getMonthKeyFromTargynap(targynap: any): string | null {
    if (!targynap) return null;

    const d = moment(targynap);
    if (!d.isValid()) return null;

    const month = d.month() + 1;
    if (month === 1) {
      const cutoff = moment(this.tanfelev, 'YYYY-MM-DD', true);
      if (cutoff.isValid() && cutoff.month() === 0) {
        return d.isSameOrBefore(cutoff, 'day') ? '01/I' : '01/II';
      }

      return d.date() <= 19 ? '01/I' : '01/II';
    }

    return String(month).padStart(2, '0');
  }

  private isValidErtekelesOktazon(oktazon: any): boolean {
    const key = String(oktazon ?? '').trim();
    return !!key && key !== 'unknown' && /^\d{6,}$/.test(key);
  }

  private isMeaningfulErtekelesItem(item: any): boolean {
    if (!item || typeof item !== 'object') return false;
    return Object.keys(item).length > 0;
  }

  private isZaroErtekelesItem(item: any): boolean {
    const modja = String(item?.modja ?? '').trim();
    if (modja === '2' || modja === '3') return true;
    if (modja === '1' || negyedevesE(item)) return false;

    const tipusNev = String(item?.ertnev ?? item?.tipus_nev ?? item?.szamonkeres_tipusa ?? item?.tema ?? '').toLowerCase();
    return tipusNev.includes('félév')
      || tipusNev.includes('felev')
      || tipusNev.includes('év végi')
      || tipusNev.includes('ev vegi')
      || tipusNev.includes('évvegi')
      || tipusNev.includes('evvegi');
  }

  private isEvvegiZaroErtekelesItem(item: any): boolean {
    const modja = String(item?.modja ?? '').trim();
    if (modja === '3') return true;

    const tipusNev = String(item?.ertnev ?? item?.tipus_nev ?? item?.szamonkeres_tipusa ?? item?.tema ?? '').toLowerCase();
    return tipusNev.includes('év végi')
      || tipusNev.includes('ev vegi')
      || tipusNev.includes('évvegi')
      || tipusNev.includes('evvegi');
  }

  private getNumericErtekeles(ertekeles: any): number | null {
    if (ertekeles === undefined || ertekeles === null) return null;
    if (typeof ertekeles === 'number') return Number.isFinite(ertekeles) ? ertekeles : null;

    const raw = String(ertekeles).trim();
    if (!raw || raw.includes('/')) return null;

    const match = raw.match(/-?\d+(?:[.,]\d+)?/);
    if (!match) return null;

    const parsed = Number(match[0].replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : null;
  }

  private getErtekelesSuly(item: any): number {
    const raw = item?.szorzo ?? item?.suly ?? item?.súly;
    if (raw === undefined || raw === null || raw === '') return 1;

    const value = typeof raw === 'number'
      ? raw
      : Number(String(raw).trim().replace(',', '.').replace('%', ''));

    /*  A 0 SÚLY IS SÚLY – és épp az a lényege.
     *
     *  A `<= 0` ág miatt a nullás szorzóból 1 lett: a „Diagnosztikus mérés (0x)"
     *  teljes súllyal számított bele az átlagba, pedig azért van 0-ra állítva, hogy
     *  NE számítson. Csak az értelmezhetetlen érték (hiányzó, szöveg, negatív) esik
     *  vissza 1-re; a kimondott 0 megmarad, és a hívó szűri ki (`weight > 0`).      */
    if (!Number.isFinite(value) || value < 0) return 1;
    return value > 10 ? value / 100 : value;
  }

  private calculateAtlag(items: any[]): { atlag: number | null; db: number; szazalek: boolean } {
    const ertekek = (items || [])
      //  A negyedéves értékelés sem számít: összegzi az évközi jegyeket, nem újabb jegy.
      //  A „nem írta meg” (–) sem: az még nem jegy. A STORNÓZOTT sem: az áthúzva látszik, de nem jegy.
      .filter((item: any) => this.isMeaningfulErtekelesItem(item) && !this.isZaroErtekelesItem(item) && !negyedevesE(item) && !nemIrtaE(item) && !stornoE(item))
      .map((item: any) => ({
        value: this.getNumericErtekeles(item?.ertekeles),
        weight: this.getErtekelesSuly(item),
        szazalek: item?.ertek_forma === 'szazalek' || String(item?.ertekeles ?? '').trim().endsWith('%'),
      }))
      .filter((item: { value: number | null; weight: number; szazalek: boolean }): item is { value: number; weight: number; szazalek: boolean } =>
        Number.isFinite(item.value as number) && Number.isFinite(item.weight) && item.weight > 0
      );

    if (!ertekek.length) return { atlag: null, db: 0, szazalek: false };

    const weightedSum = ertekek.reduce((sum, item) => sum + item.value * item.weight, 0);
    const weightSum = ertekek.reduce((sum, item) => sum + item.weight, 0);
    const atlag = weightedSum / weightSum;
    return { atlag: Math.round(atlag * 1000) / 1000, db: ertekek.length, szazalek: ertekek.every((e) => e.szazalek) };
  }

  /**
   *  Az átlag kiírása. A „%” jel CSAK százalékos jegyek átlagához jár: eddig minden
   *  átlag mögé odakerült, így egy ötös jegy átlaga „5,0%”-nak látszott, mintha a jegy
   *  százalékként ment volna be.
   */
  formatAtlag(atlag: any, szazalek = false): string {
    const value = Number(atlag);
    if (!Number.isFinite(value)) return '-';
    const decimals = this.getAtlagTizedesek();
    const formatted = value.toFixed(decimals).replace('.', ',');
    return szazalek ? `${formatted}%` : formatted;
  }

  private getAtlagTizedesek(): number {
    const raw = this.sajatIntezmeny?.ertekelesAtlagTizedes ?? this.sajatIntezmeny?.ertekeles_atlag_tizedes ?? 1;
    const value = Number(raw);
    if (!Number.isFinite(value)) return 1;
    return Math.min(3, Math.max(0, Math.trunc(value)));
  }

  private recalculateErtekelesAtlagok(adat: any): any {
    const months = adat?.months && typeof adat.months === 'object' ? adat.months : {};
    const elsoFelevItems = ['09', '10', '11', '12', '01/I'].flatMap((key) => months[key] || []);
    const evesItems = ['09', '10', '11', '12', '01/I', '01/II', '02', '03', '04', '05', '06'].flatMap((key) => months[key] || []);
    const elsoFelevAtlag = this.calculateAtlag(elsoFelevItems);
    const evesAtlag = this.calculateAtlag(evesItems);

    return {
      ...adat,
      atlagErtekelesFelev: elsoFelevAtlag.atlag,
      atlagErtekelesFelevDb: elsoFelevAtlag.db,
      atlagErtekelesFelevSzazalek: elsoFelevAtlag.szazalek,
      atlagErtekeles: evesAtlag.atlag,
      atlagErtekelesDb: evesAtlag.db,
      atlagErtekelesSzazalek: evesAtlag.szazalek,
    };
  }

  private createEmptyErtekelesAdat(oktazon: string): any {
    return {
      oktazon,
      negyedev1: [],
      negyedev2: [],
      negyedev3: [],
      negyedev4: [],
      atlagErtekeles: null,
      atlagErtekelesDb: 0,
      atlagErtekelesFelev: null,
      atlagErtekelesFelevDb: 0,
      months: {},
      felevi: [],
      evvegi: [],
    };
  }

  private getTanuloOsztalyAzonosito(tanulo: any): string | null {
    const raw = tanulo?.aktualis_osztaly_id ?? tanulo?.osztaly_id ?? tanulo?.osztaly ?? tanulo?.osztalyid ?? null;
    if (raw === undefined || raw === null || String(raw).trim() === '') return null;
    return String(raw).trim();
  }

  /*  A VÁLASZTOTT TANÍTÁSI EGYSÉG – osztály VAGY csoport.
   *
   *  A csoportok többsége TÖBB osztályt fog át (nyelvi és fakultációs csoportok a
   *  párhuzamos osztályokból), ezért nincs hozzájuk egyetlen osztály-azonosító. A
   *  képernyő eddig kizárólag osztály-azonosítóval dolgozott, és ilyenkor `null`
   *  maradt: a betöltés el sem indult, jegyet és feljegyzést beírni nem lehetett.
   *  Élő adaton (Európa 2000) a 133 csoportból 106 ilyen – vagyis a kolléga a
   *  csoportjai többségéhez hozzá sem fért.
   *
   *  Mostantól a csoport önálló egység: a kulcs a csoport, a névsort a tagsága adja,
   *  a jegy pedig tanulónként a SAJÁT osztályához kerül (ezt a kiszolgáló oldja fel). */
  get egysegKulcs(): string | null {
    return this.kivcsoport ?? this.kivosztaly ?? null;
  }

  /** A választott egység a lekérdezés-paraméterek alakjában. */
  private egysegParamok(): Record<string, string> {
    if (this.kivcsoport) return { csoport: String(this.kivcsoport) };
    return { osztaly: String(this.kivosztaly ?? '') };
  }

  private isSelectedOsztalyTanulo(tanulo: any): boolean {
    /*  CSOPORT VÁLASZTVA: a csoport névsora dönt, nem az osztályé. Egy bontott
     *  csoportnál épp az a lényeg, hogy az osztálynak csak egy része jár oda – ha az
     *  egész osztályt hoznánk, a kolléga olyan tanulóknak írna jegyet, akiket nem is
     *  tanít. A tagságot a kiszolgálótól kérjük le (`csoportTanulok`). */
    if (this.kivcsoport) {
      const oktazon = String(tanulo?.oktazon ?? '');
      return !!oktazon && this.csoportTanulok.includes(oktazon);
    }
    const tanuloOsztaly = this.getTanuloOsztalyAzonosito(tanulo);
    if (!tanuloOsztaly) return false;
    return tanuloOsztaly === String(this.kivosztaly);
  }

  private sanitizeErtekelesekResponse(ertekelesek: any): any {
    if (!ertekelesek || typeof ertekelesek !== 'object') return {};

    const sanitized: any = {};

    Object.entries(ertekelesek).forEach(([oktazon, adat]: [string, any]) => {
      if (!this.isValidErtekelesOktazon(oktazon)) return;

      const monthsRaw = (adat?.months && typeof adat.months === 'object') ? adat.months : {};
      const months: any = {};
      const felevi: any[] = [];
      const evvegi: any[] = [];
      //  A negyedéves értékelés a hónapjában jelenik meg; a záróértékelés-képernyő
      //  előtöltéséhez külön is gyűjtjük.
      const negyedev1: any[] = [];
      const negyedev2: any[] = [];
      const negyedev3: any[] = [];
      const negyedev4: any[] = [];
      const negyedevLista: Record<string, any[]> = { '4': negyedev1, '6': negyedev2, '5': negyedev3, '7': negyedev4 };

      const addRegularItemToMonth = (item: any) => {
        const monthKey = this.getMonthKeyFromTargynap(item?.targynap ?? item?.datum ?? item?.created_at);
        if (!monthKey) return;
        if (!months[monthKey]) months[monthKey] = [];
        months[monthKey].push(item);
      };

      const sortZaroOrRegular = (item: any) => {
        if (!this.isMeaningfulErtekelesItem(item)) return;
        if (negyedevesE(item)) {
          negyedevLista[String(item?.modja)].push(item);
          addRegularItemToMonth(item);
          return;
        }
        if (!this.isZaroErtekelesItem(item)) {
          addRegularItemToMonth(item);
          return;
        }

        if (this.isEvvegiZaroErtekelesItem(item)) evvegi.push(item);
        else felevi.push(item);
      };

      // A backend egyetlen listát ad (`tetelek`); a hónapokba sorolás és a záró-jegyek
      // szétválasztása itt történik, mert a januári félév-határ a megjelenített tanév
      // `felev` dátumától függ, ami csak itt ismert.
      (Array.isArray(adat?.tetelek) ? adat.tetelek : []).forEach(sortZaroOrRegular);
      (Array.isArray(adat?.felevi) ? adat.felevi : []).forEach(sortZaroOrRegular);
      (Array.isArray(adat?.evvegi) ? adat.evvegi : []).forEach(sortZaroOrRegular);

      Object.entries(monthsRaw).forEach(([monthKey, items]: [string, any]) => {
        if (!monthKey || monthKey === 'unknown') return;
        const normalizedMonthKey = monthKey === '9' ? '09' : monthKey;
        if (!months[normalizedMonthKey]) months[normalizedMonthKey] = [];

        (Array.isArray(items) ? items : []).forEach((item: any) => {
          if (!this.isMeaningfulErtekelesItem(item)) return;
          if (this.isZaroErtekelesItem(item)) {
            if (this.isEvvegiZaroErtekelesItem(item)) evvegi.push(item);
            else felevi.push(item);
            return;
          }
          months[normalizedMonthKey].push(item);
        });
      });

      sanitized[oktazon] = this.recalculateErtekelesAtlagok({
        ...this.createEmptyErtekelesAdat(oktazon),
        ...adat,
        months,
        felevi,
        evvegi,
        negyedev1,
        negyedev2,
        negyedev3,
        negyedev4,
      });
    });

    return sanitized;
  }

  private normalizeSpecialTantargyErtekelesek(ertekelesek: any): any {
    return ertekelesek;
  }

  getAktivErtekelesOsztaly(): any {
    //  A választott EGYSÉG kulcsa alatt áll – csoportnál a csoporté.
    const kulcs = this.egysegKulcs;
    if (!this.kivalasztottOra || !kulcs) return null;
    return this.kivalasztottOra?.[kulcs] ?? null;
  }

  getAktivErtekelesTantargy(): any {
    const osztaly = this.getAktivErtekelesOsztaly();
    if (!osztaly?.tantargyak) return null;

    return osztaly.tantargyak?.[this.kivtantargy]
      ?? osztaly.tantargyak?.[this.kivtantargyNev]
      ?? null;
  }


  constructor(public auth: AuthService,
          public oauth: OAuthService,private route: ActivatedRoute, private formBuilder: FormBuilder, private modalCtrl: ModalController, public viewContainerRef: ViewContainerRef, public overlay: Overlay, private http: HttpClient, private ref: ChangeDetectorRef, private data: DataService, private alertCtrl: AlertController) {
    //this.sajatIntezmeny = (this.data.getFromStorage("sajatIntezmeny"));
    this.uzemmod = this.route.snapshot.paramMap.get('uzemmod') ?? '';
    this.kivtanar = this.uzemmod
    
  }

  async ngOnInit() {
    await this.init();
    this.loadFeljegyzesTipusok();
    //this.kivosztaly = "caa92dbf-4f73-11f0-9430-525b339805da"
    //this.kivtanar = 1
    this.kivterem = null
    if (this.uzemmod == "1") {
      //this.kivtantargy = "01d890a2-4f70-11f0-9430-525b339805da"
      //this.ertekeles()
    }
    if (this.uzemmod == "2") {
      //this.kivdatum = "2026-W01"
      //this.mulasztas()
    }
    if (this.uzemmod == "3") {
      //this.kivdatum = "2026-W01"
      //this.feljegyzes()
    }
    if (this.uzemmod == "4") {
      //this.kivdatum = "2026-W01"
      //this.kivtanulo = 73413137220
      //this.tanulok()
      //this.gondviselo()
    }

    //this.init();

  }
  async ngAfterViewInit() {
    // you can now safely call getApi()
    //this.calapi = this.cal.getApi()
    //this.init();
    //this.onCalendarReady()+
    




  }

  igHatter(orak) {
    let r = ""
    if(!orak?.tantargy?.nev){
      r = 'background-color:grey;cursor: not-allowed;'
      return r
    }
    if (orak?.igazolas_tipus === undefined) {
      r = 'background-color:white;cursor: pointer;'
      if (orak.ora == 9) r += "border-right:2px solid black;"
      return r
    } else if (orak.igazolas_tipus <= -2)
      r = 'background-color:var(--ion-color-danger);cursor: pointer;'
    else if (orak.igazolas_tipus == 1)
      r = 'background-color:var(--ion-color-secondary);cursor: not-allowed;'
    else if (orak.igazolas_tipus == 2 || orak.igazolas_tipus >= 10)
      r = 'background-color:var(--ion-color-success);cursor: pointer;'
    else if (orak.igazolas_tipus == 3)
      r = 'background-color:var(--ion-color-success);cursor: pointer;'
    else if (orak.igazolas_tipus == 4)
      r = 'background-color:var(--ion-color-success);cursor: pointer;'
    else if (orak.igazolas_tipus == 5)
      r = 'background-color:var(--ion-color-success);cursor: pointer;'
    //  6 = egyéb, 7 = pályaválasztási célú távollét – szintén igazolt (eddig fehérnek, érintetlennek látszott).
    else if (orak.igazolas_tipus == 6 || orak.igazolas_tipus == 7)
      r = 'background-color:var(--ion-color-success);cursor: pointer;'
    else if (orak.igazolas_tipus == -1)
      r = 'background-color:var(--ion-color-tertiary);cursor: pointer;'
    else r = 'background-color:white;cursor: pointer;'

    if (orak.ora == 9) r += "border-right:2px solid black;"
    return r
  }
  // Cella tooltip: tantárgy/tanár + igazolás-állapot (kiemelve a zárolt orvosi igazolást)
  mulasztasCim(orak: any): string {
    if (!orak?.tantargy?.nev) return 'Nincs tanóra'
    const tg = orak.tantargy.nev
    const tanar = orak?.tanar?.nev || ''
    const it = orak.igazolas_tipus
    let allapot = ''
    if (it === 1) allapot = ' — Orvosi igazolás'
    else if (it === -1) allapot = ' — Igazolandó'
    else if (it <= -2) allapot = ' — Igazolatlan'
    else if (Number(it) === 7) allapot = ' — Igazolt (pályaválasztási célú távollét)'
    else if (it === 2 || it === 3 || it === 4 || it === 5 || Number(it) === 6 || it >= 10) allapot = ' — Igazolt'
    return `Tantárgy: ${tg}${tanar ? ', Tanár: ' + tanar : ''}${allapot}`
  }
  /*  A mulasztás-rács napjai (0 = hétfő … 5 = szombat). A szombat csak akkor kap
   *  oszlopot, ha azon a héten legalább egy tanulónak van órája vagy rögzített
   *  mulasztása – különben kilenc üres, szürke oszlop nyomta össze a táblázatot.
   *  A betöltött adathoz kötve számoljuk, hogy ne fusson minden változásészlelésnél. */
  readonly mulasztasNapNevek = ['Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'];
  private mulasztasNapokForras: any = null;
  private mulasztasNapokCache: number[] = [0, 1, 2, 3, 4];
  get mulasztasNapok(): number[] {
    const adat = this.kivalasztottOra;
    if (adat === this.mulasztasNapokForras) return this.mulasztasNapokCache;
    const szombatVan = (adat?.osztalyok?.[0]?.tanulok || []).some((t: any) =>
      (t?.orarend_igazolasok?.[5]?.orak || []).some((o: any) =>
        !!o?.tantargy?.nev || Number(o?.igazolas_tipus || 0) !== 0));
    this.mulasztasNapokForras = adat;
    this.mulasztasNapokCache = szombatVan ? [0, 1, 2, 3, 4, 5] : [0, 1, 2, 3, 4];
    return this.mulasztasNapokCache;
  }
  /*  Az orvosi igazolás SEM zárolt (a user kérése, 2026-10-07): az osztályfőnök javíthatja,
   *  pl. ha csak pár órára szól. A KRÉTA-szinkron a javítást nem írja felül. */
  mulasztasZarolt(_orak: any): boolean {
    return false
  }
  /*  IGAZOLNI CSAK AZ OSZTÁLYFŐNÖK TUD (a kiszolgáló dönti el, `jog.igazolhat`). A rácsot
   *  minden kolléga megnézheti; a kattintás viszont ne írjon olyat, amit a mentés úgyis
   *  elutasítana. Régebbi kiszolgálónál (nincs `jog` a válaszban) marad a régi viselkedés. */
  mulasztasIgazolhat = true;

  /*  EGÉSZ NAPOS JELÖLÉS (pl. CSEHÓ-nap, kirándulás): bekapcsolva egy kattintás a diák
   *  adott napjának MINDEN órájára ugyanazt az állapotot teszi – mint a KRÉTÁ-ban az
   *  osztályfőnöki X-elés. Az óra nélküli cellákhoz nem nyúl. */
  egeszNap = false;

  /*  A cella következő állapota. Egy még érintetlen (fehér) cella köre:
   *    fehér → igazolt (a sorban választott típussal) → igazolatlan → IGAZOLANDÓ (lila:
   *    hiányzott, a döntés később – pl. a szülő még igazolhat) → fehér.
   *  A már hiányzóként rögzített (lila) cella köre változatlan: lila → igazolt →
   *  igazolatlan → lila. */
  private kovetkezoAllapot(c: any): { ertek: string, uj?: boolean, ujLila?: boolean } {
    const v = c.igazolas_tipus;
    const n = (v === undefined || v === null || v === '') ? 0 : Number(v);
    if (n === 0) return { ertek: '10', uj: true };
    if (n === 10) return { ertek: '-2', uj: c.uj };
    if (n === -2) return c.uj && !c.ujLila ? { ertek: '-1', uj: true, ujLila: true } : { ertek: '0' };
    if (n === -1) return c.ujLila ? { ertek: '0' } : { ertek: '20' };
    if (n === 20) return { ertek: '-3' };
    if (n === -3) return { ertek: '-1' };
    if (n >= 1 && n < 10) return { ertek: '-2' };
    return { ertek: String(v) };
  }

  private allapotBeallit(c: any, a: { ertek: string, uj?: boolean, ujLila?: boolean }) {
    c.modosult = '1';
    c.igazolas_tipus = a.ertek;
    c.uj = !!a.uj;
    c.ujLila = !!a.ujLila;
  }

  changeOra(j, h, k) {
    if (!this.mulasztasIgazolhat) {
      this.data.sendToast('A hiányzás igazolását az osztályfőnök végzi. Itt megnézheted, módosítani nem tudod.', 'warning');
      return;
    }
    const nap = this.kivalasztottOra.osztalyok[0].tanulok[j].orarend_igazolasok[h];
    const cella = nap?.orak?.[k];
    if (!cella || !cella?.tantargy?.nev) return;
    const kov = this.kovetkezoAllapot(cella);
    if (!this.egeszNap) { this.allapotBeallit(cella, kov); return; }
    //  Egész nap: ugyanaz az állapot a nap minden órájára.
    for (const c of (nap.orak || [])) {
      if (!c?.tantargy?.nev) continue;
      this.allapotBeallit(c, kov);
    }
  }

  /*  A gondviselői nézet (uzemmod 4) tanulólistája.
   *
   *  A lista eddig betöltődött, de SEMMI nem választott belőle: a képernyő addig
   *  üres maradt, amíg a felhasználó rá nem kattintott a legördülőre. Tanulói
   *  belépésnél ez különösen zavaró, mert ott egyetlen sor van – ő maga.
   */
  tanulok(s=null){
    let si
    if(s) si=s
    else si=this.sajatIntezmeny
    this.http
      .get(
        `/api/nyilvantartas/szulogyereke/${this.user$.username}/${si.intezmenyId}`,
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.sztanulok = Array.isArray(response) ? response : []
          //  Tanulói belépés: a kiszolgáló saját magát adja vissza („saját” rokonsággal).
          //  Ilyenkor a név rögzített, nincs mit választani.
          this.sajatSor = this.data.sajatTanulo(this.sztanulok)
          if (this.sajatSor) this.kivtanulo = this.sajatSor.oktazon
          //  Egyetlen gyermeknél a szülőnek sincs mit választania.
          else if (!this.kivtanulo && this.sztanulok.length === 1) this.kivtanulo = this.sztanulok[0].oktazon
          if (this.kivtanulo) this.gondviselo()
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
  }

  mulasztas() {
    // Backendbe migrálva (régi n8n 38471274 webhook helyett)
    const params = new URLSearchParams({
      osztaly: String(this.kivosztaly),
      datum: String(this.kivdatummin),
      datum2: String(this.kivdatummax),
    });
    this.http
      .get(this.backendApiUrl('/api/mulasztas/' + this.intezmenyPath()) + '?' + params.toString())
      .subscribe({
        next: (response) => {
          this.kivalasztottOra = response
          this.mulasztasIgazolhat = (response as any)?.jog?.igazolhat !== false
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.data.sendToast("Hiba történt a mulasztások betöltésekor.", "error")
          this.data.hideLoading()
        },
      });
    // Mulasztás típusok (régi n8n f7f3c63c webhook helyett)
    this.http
      .get(this.backendApiUrl('/api/mulasztas/tipusok'))
      .subscribe({
        next: (response) => {
          this.mulasztas_tipus = response
          this.data.hideLoading()
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.data.sendToast("Hiba történt", "error")
          this.data.hideLoading()
        },
      });
  }
  saveMulasztas() {
    // Backendbe migrálva (régi n8n f836c1f6 webhook helyett)
    this.data.showLoading("Mentés...")
    this.http
      .post(
        this.backendApiUrl('/api/mulasztas/' + this.intezmenyPath()),
        { kivalasztottOra: this.kivalasztottOra }
      )
      .subscribe({
        next: (response: any) => {
          const skipped = Array.isArray(response?.skipped) ? response.skipped : []
          if (skipped.length) {
            // Típus nélkül nem mentett igazolások jelzése (a némán elveszés helyett)
            const nevek = [...new Set(skipped.map((s: any) => s.tanulo_nev).filter(Boolean))]
            this.data.sendToast(
              `${response?.updated ?? 0} óra mentve. Hiányzó igazolás-típus miatt NEM mentődött: ${nevek.join(', ')}. Válassz típust az érintett tanulóknál!`,
              "warning"
            )
          } else {
            this.data.sendToast(response?.message || "Sikeres mentés!", "success")
          }
          this.kivalasztottOra = []
          setTimeout(() => {
            this.data.hideLoading()
            this.mulasztas()
          }, 1500);
        },
        error: (error) => {
          this.data.hideLoading()
          const uzenet = error?.error?.error || "Hiba történt a mentéskor."
          this.data.sendToast(uzenet, "error")
        },
      });
  }
  loadErtekelesTipusok() {
    this.http
      .get(
        this.backendApiUrl('/api/ertekeles/tipusok'),
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.ertekelesTipus = response
          this.applySpecialErtekelesDefaults()
        },
        error: (error) => {
          console.error('Error fetching data:', error);
        },
      });
  }
  ertekeles() {
    // A jegyek a SAJÁT backendből jönnek, nem az n8n webhookból: az nem szűrt tanévre
    // (a korábbi év jegyei sosem jöttek elő), nincs verziókövetve, és a kiesése az
    // egész képernyőt megvitte. A `ev` a fejlécben választott tanév.
    const p = new URLSearchParams(this.egysegParamok());
    if (this.kivtantargy) p.set('tantargy', String(this.kivtantargy));
    if (this.megjelenitettTanev) p.set('ev', String(this.megjelenitettTanev));
    this.http
      .get(this.backendApiUrl('/api/ertekeles/osztaly/' + this.intezmenyPath()) + '?' + p.toString())
      .subscribe({
        next: (response: any) => {
          //  Kilépett / kisorolt tanulók (oktazon → utolsó nap) – a jegykulcsok közé nem kerül.
          const kilepettek: Record<string, string> = (response && typeof response._kilepettek === 'object')
            ? response._kilepettek : {};
          const ertekelesekRaw = this.sanitizeErtekelesekResponse((response && typeof response === 'object') ? response : {});
          const ertekelesek = this.normalizeSpecialTantargyErtekelesek(ertekelesekRaw);
          // A besorolás a megjelenített tanév szerint: a tanévváltás után a "mai" osztály
          // már az új, ezért egy korábbi tanév osztályára üres lett volna a névsor.
          this.http.get<any[]>(`/api/nyilvantartas/tanulo/${this.sajatIntezmeny.intezmenyId}`
            + (this.megjelenitettTanev ? `?ev=${this.megjelenitettTanev}` : '')).subscribe({
            next: (tanulok: any[]) => {
              this.intezmenyTanulok = Array.isArray(tanulok) ? tanulok : [];

              const tanuloMap = this.intezmenyTanulok.reduce((acc: any, tanulo: any) => {
                if (tanulo?.oktazon) {
                  acc[String(tanulo.oktazon)] = tanulo;
                }
                return acc;
              }, {});

              const osztalyTanulok = this.intezmenyTanulok
                .filter((tanulo: any) => this.isSelectedOsztalyTanulo(tanulo))
                .map((tanulo: any) => {
                  const oktazon = String(tanulo.oktazon);
                  if (!ertekelesek[oktazon]) {
                    ertekelesek[oktazon] = this.createEmptyErtekelesAdat(oktazon);
                  }

                  return {
                    oktazon,
                    nev: `${tanulo?.viselt_vez || ''} ${tanulo?.viselt_ker || ''}`.trim()
                      || tanulo?.full_name
                      || oktazon,
                    viselt_vez: tanulo?.viselt_vez || '',
                    viselt_ker: tanulo?.viselt_ker || '',
                    osztaly_id: this.getTanuloOsztalyAzonosito(tanulo),
                    email: tanulo?.email || null,
                  };
                });

              const fallbackTanulok = Object.entries(ertekelesek)
                .map(([oktazon, item]: [string, any]) => {
                  const tanulo = tanuloMap[String(oktazon)] || {};
                  const viselt_vez = tanulo?.viselt_vez || item?.viselt_vez || '';
                  const viselt_ker = tanulo?.viselt_ker || item?.viselt_ker || '';
                  const nev = `${viselt_vez} ${viselt_ker}`.trim()
                    || tanulo?.full_name
                    || item?.nev
                    || String(oktazon);

                  return {
                    oktazon,
                    nev,
                    viselt_vez,
                    viselt_ker,
                    osztaly_id: this.getTanuloOsztalyAzonosito(tanulo),
                  };
                })
                .filter((tanulo: any) => !tanulo.osztaly_id || String(tanulo.osztaly_id) === String(this.kivosztaly))
                .filter((tanulo: any) => !osztalyTanulok.some((existing: any) => String(existing.oktazon) === String(tanulo.oktazon)));

              /*  A KILÉPETT / KISOROLT TANULÓ (user, 2026-10-03): ha van jegye, a törzslap miatt
               *  év végéig itt marad, de szürkén, a lista alján; ha nincs, nem jelenik meg. */
              const vanJegye = (okt: string) => {
                const e: any = ertekelesek[okt];
                return !!(e && ((e.tetelek?.length) || Object.keys(e.months || {}).length || e.felevi?.length || e.evvegi?.length));
              };
              const osztaly_nevsor = [...osztalyTanulok, ...fallbackTanulok]
                .filter((t: any) => !kilepettek[String(t.oktazon)] || vanJegye(String(t.oktazon)))
                .map((t: any) => (kilepettek[String(t.oktazon)] ? { ...t, kilepett: kilepettek[String(t.oktazon)] } : t))
                .sort((a: any, b: any) => (a.kilepett ? 1 : 0) - (b.kilepett ? 1 : 0) || a.nev.localeCompare(b.nev, 'hu'));

              this.kivalasztottOra = {
                datum: this.kivalasztottOra?.datum ?? moment().format('YYYY-MM-DD'),
                konyvelte: this.user$?.username ?? null,
                konyvelve: moment().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                osztalyid: this.kivosztaly,
                csoportid: this.kivcsoport,
                tantargyid: this.kivtantargy,
                tantargy: this.kivtantargyNev,
                osztaly_nevsor,
                ertekelesek,
                osztalyozasimod: this.valasztottOsztalyozasiMod(),
                szam_tipus: this.kivalasztottOra?.szam_tipus ?? null,
                szam_tema: this.kivalasztottOra?.szam_tema ?? null,
              };

              this.applySpecialErtekelesDefaults()
              this.osztalyozasiModZarSzamol()
              this.prefillZaroErtekelesek()

              this.data.hideLoading()
            },
            error: (error) => {
              console.error('Error fetching student roster:', error);

              const osztaly_nevsor = Object.entries(ertekelesek)
                .map(([oktazon, item]: [string, any]) => ({
                  oktazon,
                  nev: `${item?.viselt_vez || ''} ${item?.viselt_ker || ''}`.trim() || String(oktazon),
                  viselt_vez: item?.viselt_vez || '',
                  viselt_ker: item?.viselt_ker || '',
                }))
                .sort((a: any, b: any) => a.nev.localeCompare(b.nev, 'hu'));

              this.kivalasztottOra = {
                datum: this.kivalasztottOra?.datum ?? moment().format('YYYY-MM-DD'),
                konyvelte: this.user$?.username ?? null,
                konyvelve: moment().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                osztalyid: this.kivosztaly,
                csoportid: this.kivcsoport,
                tantargyid: this.kivtantargy,
                tantargy: this.kivtantargyNev,
                osztaly_nevsor,
                ertekelesek,
                osztalyozasimod: this.valasztottOsztalyozasiMod(),
                szam_tipus: this.kivalasztottOra?.szam_tipus ?? null,
                szam_tema: this.kivalasztottOra?.szam_tema ?? null,
              };

              this.applySpecialErtekelesDefaults()
              this.osztalyozasiModZarSzamol()
              this.prefillZaroErtekelesek()

              this.data.hideLoading()
            },
          });

        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.data.sendToast("Hiba történt", "error")
          this.data.hideLoading()

        },
      });
    //this.ertekelesmodal.present()
  }
  /**
   *  Korábbi (vagy előkészített) tanévet nézünk-e. Ilyenkor a képernyő OLVASHATÓ,
   *  de nem szabad bele írni: a jegy mindig abba a tanévbe kerülne, amelyikben az
   *  intézmény éppen van, nem abba, amit a felhasználó néz.
   */
  get masTanevetNez(): boolean {
    return this.megjelenitettTanev != null && this.aktualisTanev != null
      && Number(this.megjelenitettTanev) !== Number(this.aktualisTanev);
  }

  tanevNeve(ev: number | null): string {
    return ev == null ? '' : `${ev}/${Number(ev) + 1}`;
  }


  /* ══════════════════════════════════════════════════════════════════════
   *  TÖMEGES ÉRTÉKELÉS
   *
   *  Egy dolgozat után 25 tanulónak egyenként beírni ugyanazt a jegyet fölösleges
   *  kattintás. A típust a fenti választó adja, tehát ez BÁRMELYIK értékelési
   *  típusnál működik – csak az értéket írjuk be a névsorba, a mentés a megszokott.
   * ═══════════════════════════════════════════════════════════════════ */

  /** A számmezős (jegy/százalék) tömeges kitöltés beviteli értéke. */
  tomegesErtekMezo: any = '';

  get tomegesUresek(): number {
    return uresekSzama(this.kivalasztottOra?.osztaly_nevsor || []);
  }

  /**
   *  @param ertek    a beírandó érték ('' = törlés)
   *  @param hatokor  'mind' = mindenkinek, 'ures' = csak akinek még nincs
   *  @param mezo     fokozat-módban a szorgalom külön mező
   */
  tomegesErtek(ertek: any, hatokor: 'mind' | 'ures' = 'mind', mezo: 'osztalyzat' | 'szorgalomodost' = 'osztalyzat') {
    const nevsor = this.kivalasztottOra?.osztaly_nevsor || [];
    if (!nevsor.length) return;
    const db = tomegesErtekeles(nevsor, ertek, hatokor, mezo);
    const mit = String(ertek ?? '').trim() === '' ? 'törölve' : `„${ertek}" beírva`;
    this.data.sendToast(`${db} tanulónál ${mit}${hatokor === 'ures' ? ' (csak az üresek)' : ''}.`,
      db ? 'success' : 'warning');
  }

  /** A számmezőbe írt érték kiosztása. */
  tomegesSzam(hatokor: 'mind' | 'ures' = 'mind') {
    const ertek = String(this.tomegesErtekMezo ?? '').trim();
    if (!ertek) { this.data.sendToast('Előbb add meg az értéket.', 'warning'); return; }
    this.tomegesErtek(ertek, hatokor);
  }

  /*  Üres témára RÁKÉRDEZÜNK — egyszer, és csak ott, ahol a témának értelme van.
   *  A „mihez tartozik ez a jegy?" kérdés fél év múlva jön elő, amikor már senki nem
   *  emlékszik; egy kattintással megelőzhető. Magatartás/szorgalom és záró értékelés
   *  nem dolgozathoz tartozik, ott nem kérdezünk. */
  private temaKerdezve = false;

  private temaRendben(): boolean {
    if (String(this.kivalasztottOra?.szam_tema ?? '').trim()) return true;
    if (this.isMagatartasSzorgalomTantargy()) return true;
    if (this.temaKerdezve) return true;
    const mehet = confirm('A Téma mező üres, így a jegyek mellé nem kerül téma.\n\n'
      + 'Fél év múlva ebből nem lesz kideríthető, melyik dolgozatról volt szó.\n\n'
      + 'Így mentsem?');
    if (mehet) this.temaKerdezve = true;
    return mehet;
  }

  /*  MENTÉS KÖZBEN NINCS MÁSODIK KATTINTÁS. A mentés nem azonnali (a kiszolgáló a jegyeket
   *  egyenként írja és visszatölti a listát); közben a Mentés újranyomása ugyanazt a
   *  névsort MÁSODSZOR is elküldte – így lettek duplán a jegyek (Európa 2000, 2026-09-21).
   *  A várakozásjelző a képernyőt is lefedi, hogy közben ne lehessen máshová kattintani. */
  jegyMentesFolyamatban = false;

  /*  NKP-EREDMÉNYEK: a bemásolt listából a névsor mezőit tölti ki (nem ment). A tanár
   *  ellenőrzi, és a megszokott Mentés gombbal rögzít – ugyanazokkal az ellenőrzésekkel. */
  async nkpBeillesztes() {
    const nevsor = (this.kivalasztottOra?.osztaly_nevsor || [])
      .map((t: any) => ({ oktazon: String(t.oktazon), nev: t.nev || `${t.viselt_vez || ''} ${t.viselt_ker || ''}`.trim(), email: t.email || null }));
    const m = await this.modalCtrl.create({
      component: NkpBeillesztesComponent,
      componentProps: {
        nevsor,
        mod: this.kivalasztottOra?.osztalyozasimod === '1' ? '1' : '2',
        modZarolt: !!this.osztalyozasiModZar,
      },
      cssClass: 'nkp-modal',
    });
    await m.present();
    const { data, role } = await m.onWillDismiss();
    if (role !== 'ok' || !data?.ertekek) return;
    if (!this.osztalyozasiModZar && data.mod) this.kivalasztottOra.osztalyozasimod = data.mod;
    let db = 0;
    for (const t of (this.kivalasztottOra?.osztaly_nevsor || [])) {
      const e = data.ertekek[String(t.oktazon)];
      if (e === undefined) continue;
      t.osztalyzat = e;
      db += 1;
    }
    this.data.sendToast(`${db} tanulónál kitöltve. Ellenőrizd a névsort, add meg a típust és a témát, majd Mentés.`, 'success');
    this.ref.detectChanges();
  }

  async saveErtekeles() {
    if (this.jegyMentesFolyamatban) return;
    if (!this.temaRendben()) return;
    if (this.masTanevetNez) {
      this.data.sendToast(
        `A ${this.tanevNeve(this.megjelenitettTanev)} tanévet nézed, az intézmény aktuális tanéve `
        + `${this.tanevNeve(this.aktualisTanev)}. Értékelést csak az aktuális tanévbe lehet rögzíteni – `
        + 'válts vissza a fejléc tanév-választójában.', 'error');
      return;
    }
    //this.ertekelesmodal.dismiss()
    const payloadOra = {
      ...this.kivalasztottOra,
      szam_tipus: this.kivalasztottOra?.szam_tipus ? String(this.kivalasztottOra.szam_tipus) : null,
      osztaly_nevsor: (this.kivalasztottOra?.osztaly_nevsor || []).map((tanulo: any) => {
        if (!this.isDualFokozatMode()) return { ...tanulo };

        return {
          ...tanulo,
          osztalyzat: this.getCombinedDualFokozat(tanulo),
        };
      }),
    };

    const beszamoloId = this.getBeszamoloTipusId();
    if (this.isMagatartasSzorgalomTantargy() && beszamoloId) {
      payloadOra.szam_tipus = beszamoloId;
    }

    console.log(payloadOra)
    this.jegyMentesFolyamatban = true;
    await this.data.showLoading('Jegyek mentése…');
    this.http
      .post(
        this.backendApiUrl('/api/ertekeles/mentes'),
        { kivalasztottOra: payloadOra },
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.jegyMentesFolyamatban = false;
          try { this.data.hideLoading() } catch (e) { }
          this.kivalasztottOra?.osztaly_nevsor?.forEach((k: any) => {
            delete k.osztalyzat;
            delete k.szorgalomodost;
          });
  /*  A TÉMA NEM VÉSZ EL A MENTÉSSEL.
   *
   *  Eddig a sikeres mentés után a képernyő TÖRÖLTE a Téma mezőt. Egy dolgozat jegyeit
   *  viszont ritkán írja be valaki egy menetben: aki a névsor felét most, a másik felét
   *  öt perc múlva rögzíti, annál a második adag már téma NÉLKÜL ment el — csendben.
   *  A kolléga ebből azt látja, hogy „a rendszer nem menti a témát" (Európa 2000,
   *  2026-09-23, fizika és kémia), pedig a téma bement, csak a mező ürült ki közben.
   *
   *  Ezért a téma MARAD a mentés után: ugyanahhoz a dolgozathoz ugyanaz a téma való.
   *  A névsor értékei ürülnek (azok tanulónként mások), a téma nem. */
          /*  HA VALAKI KIMARADT, AZT MEG KELL MONDANI. Csoportos beírásnál a jegy a
           *  tanuló SAJÁT osztályához kerül – akinek nincs élő besorolása, annál nincs
           *  hova tenni. Egy néma kihagyás azt a látszatot keltené, hogy bement. */
          const kimaradt = (response as any)?.osztaly_nelkul_nevek || (response as any)?.osztaly_nelkul || [];
          const mentve = Number((response as any)?.mentve) || 0
          const mentveSzoveg = mentve === 1 ? "1 jegy mentve." : `${mentve} jegy mentve.`
          //  Egyéni munkarend: neki jegy csak osztályozó vizsgából adható – megnevezzük.
          const emNevek = (response as any)?.egyeni_munkarend_nevek || []
          /*  JEGYBEÍRÁSI HATÁRIDŐ (20/2012. EMMI r. 64. § (1a)): a jegy bement, de a jegy napjától
           *  számítva az iskola határidején túl. Nem hiba – csak egy mondat a visszajelzés végén. */
          const kesesMegj = (response as any)?.kesve?.uzenet ? ` ${(response as any).kesve.uzenet}` : ''
          if (emNevek.length && !kimaradt.length) {
            this.data.sendToast(`${mentveSzoveg} Nem ment be: ${emNevek.slice(0, 5).join(', ')}${emNevek.length > 5 ? '…' : ''} – `
              + 'egyéni munkarendű, neki jegy csak osztályozó vizsgából adható.' + kesesMegj, "warning")
          } else if (kimaradt.length) {
            //  Egy üzenetben: két egymás utáni értesítés közül csak a második látszana.
            this.data.sendToast(`${mentveSzoveg} Nem ment be: ${kimaradt.slice(0, 5).join(', ')}`
              + `${kimaradt.length > 5 ? '…' : ''} – nincs osztályba besorolva (az admin az Osztálybesorolásban pótolhatja).` + kesesMegj, "warning")
          } else {
            //  A téma a visszajelzésben is szerepel: így látszik, hogy bement.
            const temaSzoveg = String(this.kivalasztottOra?.szam_tema ?? '').trim()
            this.data.sendToast((temaSzoveg ? `${mentveSzoveg} Téma: ${temaSzoveg}` : mentveSzoveg) + kesesMegj, kesesMegj ? "warning" : "success")
          }
          this.ertekeles()
        },
        error: (error) => {
          this.jegyMentesFolyamatban = false;
          //  A kiszolgáló megmondja, mi a baj (pl. eltérő osztályozási mód) – az kerüljön
          //  ki, ne az „[object Object]”.
          try { this.data.hideLoading() } catch (e) { }
          this.data.sendToast(error?.error?.error || "Hiba történt a mentéskor.", "error")
        },
      });
  }

  onZaroTipusValtozas() {
    this.prefillZaroErtekelesek();
  }

  prefillZaroErtekelesek() {
    if (this.uzemmod !== '5' || !this.kivalasztottOra?.osztaly_nevsor || !this.kivalasztottOra?.ertekelesek) return;

    this.kivalasztottOra.osztaly_nevsor = this.kivalasztottOra.osztaly_nevsor.map((tanulo: any) => {
      const adat = this.kivalasztottOra.ertekelesek?.[tanulo?.oktazon] || {};
      const lista = ({ '2': adat.felevi, '3': adat.evvegi, '4': adat.negyedev1, '6': adat.negyedev2, '5': adat.negyedev3, '7': adat.negyedev4 } as any)[this.zaroTipus] || [];
      //  A stornózott záró jegy nem él: az előtöltés az élő értékből indul (ha nincs, üresen).
      const elso = (lista || []).find((x: any) => !stornoE(x));
      //  Szöveg nélküli jegynél a szöveg maga a rövid alak („5D”) – a szövegmezőbe nem tesszük.
      const rovid = elso ? strukturaltRovid(elso) : null;
      const aktualis = elso && !(rovid && String(elso.ertekeles ?? '').trim() === rovid) ? (elso.ertekeles ?? '') : '';
      const ertek = elso?.ertek_forma === 'jegy' && Number(elso?.dicseretes) === 1 && Number(elso?.ertek_szam) === 5
        ? '5D' : (elso?.ertek_szam ?? null);
      const ertekForma = elso?.ertek_forma ?? null;
      return {
        ...tanulo,
        osztalyzat: aktualis,
        ertek,
        ertekForma,
      };
    });
    this.loadZaroFormak();
  }

  // A kiválasztott osztály évfolyamára engedélyezett záróértékelési formák
  // (admin által, tantárgy + évfolyam szinten). Több forma is engedélyezett lehet.
  loadZaroFormak() {
    this.zaroFormak = ['szoveges'];
    const intezmenyId = this.intezmenyPath();
    const ev = String(moment(this.tankezd).format('YYYY'));
    const tantargy = String(this.kivtantargy || this.kivalasztottOra?.tantargyid || '');
    const evfolyam = this.getZaroEvfolyam();
    if (!intezmenyId || !ev || !tantargy || !evfolyam) return;
    const params = new URLSearchParams({ ev, tantargy, evfolyam });
    this.http
      .get<any[]>(this.backendApiUrl('/api/ertekeles-forma/' + intezmenyId) + '?' + params.toString())
      .subscribe({
        next: (rows) => {
          const formak = Array.isArray(rows) && rows.length && Array.isArray(rows[0]?.formak)
            ? rows[0].formak
            : ['szoveges'];
          this.zaroFormak = formak.length ? formak : ['szoveges'];
          this.alkalmazZaroFormaAlap();
        },
        error: () => {
          this.zaroFormak = ['szoveges'];
          this.alkalmazZaroFormaAlap();
        },
      });
  }

  // Minden tanulóhoz beállít egy érvényes formát: a meglévőt, ha engedélyezett,
  // egyébként az első engedélyezettet.
  private alkalmazZaroFormaAlap() {
    const sorok = this.kivalasztottOra?.osztaly_nevsor || [];
    for (const n of sorok) {
      if (!n.ertekForma || !this.zaroFormak.includes(n.ertekForma)) {
        n.ertekForma = this.zaroFormak[0] || 'szoveges';
      }
    }
  }

  getZaroAtlag(tanulo: any): string {
    const adat = this.kivalasztottOra?.ertekelesek?.[tanulo?.oktazon] || {};
    //  Az I. és a II. negyedévnél még csak az első félév jegyei vannak – annak az átlaga számít.
    return ['2', '4', '6'].includes(this.zaroTipus)
      ? this.formatAtlag(adat?.atlagErtekelesFelev, adat?.atlagErtekelesFelevSzazalek)
      : this.formatAtlag(adat?.atlagErtekeles, adat?.atlagErtekelesSzazalek);
  }

  openZaroJegyek(tanulo: any) {
    this.zaroJegyekTanulo = tanulo;
    this.zaroJegyekModalOpen = true;
  }

  closeZaroJegyek() {
    this.zaroJegyekModalOpen = false;
    this.zaroJegyekTanulo = null;
  }

  private getZaroTanuloKey(tanulo: any): string {
    return String(tanulo?.oktazon || tanulo?.adid || tanulo?.id || '').trim();
  }

  getZaroTantargyNev(): string {
    const selectedTantargy = this.tantargy?.find((t: any) => String(t.id) === String(this.kivtantargy));
    return String(
      this.kivalasztottOra?.tantargy
      || this.kivtantargyNev
      || selectedTantargy?.name
      || selectedTantargy?.nev
      || ''
    ).trim();
  }

  getZaroEvfolyam(): string {
    const selectedOsztaly = this.osztaly?.find((o: any) => String(o.id) === String(this.kivosztaly));
    const raw = String(
      this.kivalasztottOra?.evfolyam
      || this.kivalasztottOra?.osztaly
      || this.kivalasztottOra?.osztaly_nev
      || selectedOsztaly?.evfolyam
      || selectedOsztaly?.osztaly
      || selectedOsztaly?.nev
      || selectedOsztaly?.name
      || ''
    ).trim();
    const match = raw.match(/\d+/);
    return match?.[0] || raw;
  }

  async rememberZaroTextareaCursor(tanulo: any, textarea: any) {
    const key = this.getZaroTanuloKey(tanulo);
    if (!key || !textarea?.getInputElement) return;

    try {
      const input = await textarea.getInputElement();
      this.zaroTextareaCursor[key] = {
        start: Number(input.selectionStart ?? String(tanulo?.osztalyzat || '').length),
        end: Number(input.selectionEnd ?? String(tanulo?.osztalyzat || '').length),
      };
    } catch {
      this.zaroTextareaCursor[key] = {
        start: String(tanulo?.osztalyzat || '').length,
        end: String(tanulo?.osztalyzat || '').length,
      };
    }
  }

  openZaroMondatbank(tanulo: any) {
    this.zaroMondatbankTanulo = tanulo;
    this.zaroMondatbankKereses = '';
    this.zaroMondatbankModalOpen = true;
    this.loadZaroMondatbank();
  }

  closeZaroMondatbank() {
    this.zaroMondatbankModalOpen = false;
    this.zaroMondatbankTanulo = null;
    this.zaroMondatbankKereses = '';
  }

  loadZaroMondatbank() {
    const evfolyam = this.getZaroEvfolyam();
    const tantargy = this.getZaroTantargyNev();

    if (!evfolyam || !tantargy) {
      this.zaroMondatbank = [];
      return;
    }

    const params = new URLSearchParams({
      evfolyam,
      tantargy,
      //  A mondatbank félévi / év végi bontású; a negyedéves a félévéhez tartozó mondatokat kapja.
      zaroTipus: ['4', '6'].includes(this.zaroTipus) ? '2' : ['5', '7'].includes(this.zaroTipus) ? '3' : this.zaroTipus,
    });

    this.zaroMondatbankLoading = true;
    this.http
      .get<any[]>(this.backendApiUrl('/api/ertekeles-zaro/mondatbank/' + this.intezmenyPath()) + '?' + params.toString())
      .subscribe({
        next: (rows) => {
          this.zaroMondatbank = Array.isArray(rows) ? rows : [];
          this.zaroMondatbankLoading = false;
        },
        error: (error) => {
          console.error('Mondatbank betöltési hiba:', error);
          this.zaroMondatbank = [];
          this.zaroMondatbankLoading = false;
          this.data.sendToast('Nem sikerült betölteni a mondatbankot.', 'error');
        },
      });
  }

  getFilteredZaroMondatbank(): any[] {
    const q = this.zaroMondatbankKereses.trim().toLowerCase();
    if (!q) return this.zaroMondatbank;

    return this.zaroMondatbank.filter((item: any) => {
      const haystack = `${item?.szoveg || ''} ${item?.rovid_nev || ''} ${item?.tantargy || ''}`.toLowerCase();
      return haystack.includes(q);
    });
  }

  isZaroMondatbankCimke(item: any): boolean {
    const value = this.normalizeMondatbankCimke(item?.szoveg);
    return [
      'példás',
      'jeles',
      'jó',
      'változó',
      'hanyag',
      'rossz',
      'közepes',
      'fejlesztendő',
      'elégséges',
      'elégtelen',
    ].map((label) => this.normalizeMondatbankCimke(label)).includes(value);
  }

  private normalizeMondatbankCimke(value: any): string {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  insertZaroMondat(item: any) {
    if (!this.zaroMondatbankTanulo) return;

    const mondat = String(item?.szoveg || '').trim();
    if (!mondat || this.isZaroMondatbankCimke(item)) return;

    const tanulo = this.zaroMondatbankTanulo;
    const key = this.getZaroTanuloKey(tanulo);
    const current = String(tanulo?.osztalyzat || '');
    const fallbackPosition = current.length;
    const cursor = key ? this.zaroTextareaCursor[key] : null;
    const start = Math.max(0, Math.min(Number(cursor?.start ?? fallbackPosition), current.length));
    const end = Math.max(start, Math.min(Number(cursor?.end ?? start), current.length));
    const prefix = current.slice(0, start);
    const suffix = current.slice(end);

    let insertion = mondat;
    if (start === current.length && current.trim()) {
      insertion = `\n${mondat}`;
    } else {
      if (prefix && !/\s$/.test(prefix)) insertion = ` ${insertion}`;
      if (suffix && !/^\s/.test(suffix)) insertion = `${insertion} `;
    }

    tanulo.osztalyzat = `${prefix}${insertion}${suffix}`;
    if (key) {
      const newPosition = prefix.length + insertion.length;
      this.zaroTextareaCursor[key] = { start: newPosition, end: newPosition };
    }
  }

  getZaroJegyekAdat(tanulo: any = this.zaroJegyekTanulo): any {
    return this.kivalasztottOra?.ertekelesek?.[tanulo?.oktazon] || {};
  }

  getZaroHonapJegyek(honap: string): any[] {
    const adat = this.getZaroJegyekAdat();
    return adat?.months?.[honap] || [];
  }

  getZaroCim(): string {
    return ({ '2': 'Félévi értékelés', '3': 'Év végi értékelés', ...NEGYEDEV_NEV } as any)[this.zaroTipus] || 'Záróértékelés';
  }

  /* ── negyedéves és dicséretes jegy megjelenítése ── */
  negyedevesE = negyedevesE;

  negyedevJel(item: any): string {
    return NEGYEDEV_JEL[String(item?.modja)] || '';
  }

  negyedevNev(item: any): string {
    return NEGYEDEV_NEV[String(item?.modja)] || '';
  }

  /** A jegy rövid alakja: záró/negyedéves érdemjegynél „5D”, „4”, „85%”, egyébként a szokásos. */
  jegyRovid(item: any): string {
    if (nemIrtaE(item)) return NEM_IRTA_JEL;
    return strukturaltRovid(item) ?? this.formatErtekelesRovid(item?.ertekeles);
  }

  /* ── „nem írta meg” (–) ──
   *  Jegy helyett mínusz annak, aki a dolgozatot nem írta meg (mint a KRÉTÁ-ban). Nem
   *  jegy: az átlagba nem számít, a KRÉTÁ-ba nem megy; amikor pótolta, a jegyre kattintva
   *  a „Jegy beírása” gombbal írható át. Csak osztályzat és százalék módban. */
  readonly NEM_IRTA_JEL = NEM_IRTA_JEL;
  nemIrtaE = nemIrtaE;

  /*  A JEGY RÉSZLETEI EGÉRRE IS (Hamvas-Fekete Anikó, 2026-10-12; user, 10-14): eddig csak
   *  kattintásra nyíló buborékban látszott, mi lett beírva. A ráállás most a böngésző súgójában
   *  mutatja ugyanezt; a kattintásra nyíló buborék a Módosítás / Törlés gombok miatt marad. */
  jegyHover(item: any): string {
    if (!item) return '';
    const sorok: string[] = [];
    if (stornoE(item)) {
      sorok.push(`STORNÓZVA${item.storno_ido ? ` (${String(item.storno_ido).slice(0, 16)})` : ''} – nem számít`);
      if (item.storno_ok) sorok.push(`Ok: ${item.storno_ok}`);
    }
    if (this.nemIrtaE(item)) sorok.push('Nem írta meg');
    const special = this.getSpecialErtekelesReszletek(item.ertekeles);
    if (special) sorok.push(`Magatartás: ${special.magatartas}`, `Szorgalom: ${special.szorgalom}`);
    else if (String(item.ertekeles ?? '').length > 4) sorok.push(`Értékelés: ${item.ertekeles}`);
    if (item.tema) sorok.push(`Téma: ${item.tema}`);
    if (item.targynap) sorok.push(`Dátum: ${String(item.targynap).slice(0, 10)}`);
    const tipus = this.negyedevesE(item) ? this.negyedevNev(item) : (item.emnev || '');
    if (tipus) sorok.push(`Típus: ${tipus}`);
    if (item.szorzo !== undefined && item.szorzo !== null && item.szorzo !== '') sorok.push(`Súlyozás: ${item.szorzo}%`);
    const self: any = this;
    const tanar = typeof self.formatErtekelesTanar === 'function' ? self.formatErtekelesTanar(item)
      : (item.tanar_nev || item.tanarnev || item.tanar || '');
    if (tanar) sorok.push(`Tanár: ${tanar}`);
    if (item.modositva) sorok.push(`Módosítva: ${String(item.modositva).replace('T', ' ').slice(0, 16)}`);
    return sorok.join('\n');
  }
  nemIrtaJelE = nemIrtaJelE;

  get nemIrtaLehet(): boolean {
    return nemIrtaModE(this.kivalasztottOra?.osztalyozasimod);
  }

  /** A tanuló sorában a „–” gomb: be- és kikapcsolja a jelölést. */
  nemIrtaValt(tanulo: any) {
    if (!tanulo) return;
    tanulo.osztalyzat = nemIrtaJelE(tanulo.osztalyzat) ? '' : NEM_IRTA_JEL;
  }

  /** Egy beírt jegy módosítása helyben (érték, dátum, téma – a forma marad). */
  /** A saját kilétem azonosítói – ehhez mérjük, kié a jegy vagy a feljegyzés. */
  get enyemKulcsok(): string[] {
    return [this.user$?.adid, this.user$?.preferred_username, this.user$?.username, this.user$?.email];
  }

  /** Az én tételem-e (jegy, feljegyzés)? Adminnál mindig igen. */
  sajatTetel(item: any): boolean {
    return sajatTetelE(item, this.enyemKulcsok, !!this.tanitottAdmin);
  }

  async modositJegy(item: any) {
    const adat = await jegyModositasBekeres(this.alertCtrl, item);
    if (!adat) return;
    await this.data.showLoading('Módosítás...');
    this.http.post(this.backendApiUrl('/api/ertekeles/modositas'), {
      ...adat,
      intezmeny: this.sajatIntezmeny?.intezmenyId,
    }).subscribe({
      next: (r: any) => {
        this.data.hideLoading();
        this.data.sendToast(r?.kreta_figyelmeztetes
          ? 'A jegy módosítva. Már a KRÉTÁ-ban is szerepel – a következő KRÉTA-szinkron ott is kijavítja.'
          : 'A jegy módosítva.', 'success');
        this.ertekeles();
      },
      error: (e) => {
        this.data.hideLoading();
        this.data.sendToast(e?.error?.error || 'Nem sikerült módosítani a jegyet.', 'error');
      },
    });
  }

  formatErtekelesTanar(item: any): string {
    const explicitName = String(
      item?.tanar_nev
      || item?.tanarNev
      || item?.pedagogus_nev
      || item?.pedagogusNev
      || ''
    ).trim();
    if (explicitName) return explicitName;

    const nameParts = [
      item?.telo || item?.tanar_elo || item?.viselt_elo,
      item?.tvez || item?.tanar_vez || item?.viselt_vez,
      item?.tker || item?.tanar_ker || item?.viselt_ker,
    ]
      .map((part) => String(part || '').trim())
      .filter(Boolean);
    if (nameParts.length) return nameParts.join(' ');

    const tanarAzonosito = String(item?.tanar || item?.tanar_azonosito || '').trim();
    if (tanarAzonosito) {
      const tanar = (this.allomany || []).find((a: any) =>
        String(a?.adid || '').trim() === tanarAzonosito
        || String(a?.oktazon || '').trim() === tanarAzonosito
        || String(a?.auth0id || '').trim() === tanarAzonosito
        || String(a?.username || '').trim() === tanarAzonosito
      );

      const resolvedName = [
        tanar?.viselt_elo,
        tanar?.viselt_vez,
        tanar?.viselt_ker,
      ]
        .map((part) => String(part || '').trim())
        .filter(Boolean)
        .join(' ');

      if (resolvedName) return resolvedName;
    }

    return tanarAzonosito || '-';
  }

  saveZaroErtekeles() {
    if (!this.kivalasztottOra?.datum) {
      this.data.sendToast('A dátum megadása kötelező.', 'error');
      return;
    }

    const payloadOra = {
      ...this.kivalasztottOra,
      szam_tipus: '19',
      zaroTipus: this.zaroTipus,
      szam_tema: this.kivalasztottOra?.szam_tema || this.getZaroCim(),
      osztaly_nevsor: (this.kivalasztottOra?.osztaly_nevsor || []).map((tanulo: any) => {
        const forma = this.zaroFormak.includes(tanulo?.ertekForma) ? tanulo.ertekForma : (this.zaroFormak[0] || 'szoveges');
        return {
          ...tanulo,
          osztalyzat: String(tanulo?.osztalyzat ?? '').trim(),
          ertekForma: forma,
          //  5D (dicséretes ötös) szövegként megy; a kiszolgáló bontja 5-re és a jelölőre.
          ertek: forma === 'szoveges' ? null : (tanulo?.ertek ?? null),
        };
      }),
    };

    this.data.showLoading('Záróértékelések mentése...');
    this.http.post(this.backendApiUrl('/api/ertekeles-zaro/' + this.intezmenyPath()), {
      kivalasztottOra: payloadOra,
      zaroTipus: this.zaroTipus,
    }).subscribe({
      next: (response: any) => {
        this.data.hideLoading();
        //  A változatlan sorhoz a mentés nem nyúl; a kiürített sor stornózódik (áthúzva marad).
        const reszek = [`Mentve: ${response?.mentve ?? 0} értékelés`];
        if (response?.valtozatlan) reszek.push(`változatlan: ${response.valtozatlan}`);
        if (response?.torolve) reszek.push(`stornózva: ${response.torolve}`);
        //  Negyedéves értékelés a jegybeírási határidőn túl (2026-11-02): bement, csak jelezzük.
        const kesesMegj = response?.kesve?.uzenet ? ` ${response.kesve.uzenet}` : '';
        this.data.sendToast(reszek.join(', ') + '.' + kesesMegj, kesesMegj ? 'warning' : 'success');
        this.ertekeles();
      },
      error: (error) => {
        this.data.hideLoading();
        console.error('Záróértékelés mentési hiba:', error);
        this.data.sendToast('Hiba történt a záróértékelések mentésekor.', 'error');
      },
    });
  }

  private getAktualisTanevEv(): number {
    const ev = Number(moment(this.tankezd).format('YYYY'));
    return Number.isFinite(ev) ? ev : Number(moment().format('YYYY'));
  }

  resetSzamonkeresForm() {
    this.szamonkeresForm = {
      id: null,
      datum: moment().format('YYYY-MM-DD'),
      tipus: this.ertekelesTipus?.find((t: any) => !this.isTechnikaiErtekelesTipus(t) && !Number(t?.rejtett))?.id ?? null,
      cim: '',
      leiras: ''
    };
  }

  loadSzamonkeresek(showLoader = true) {
    if (!this.sajatIntezmeny || !this.egysegKulcs || !this.kivtantargy) return;

    if (showLoader) this.data.showLoading('Számonkérések betöltése...');
    /*  Osztály VAGY csoport – ugyanaz a paraméter-alak, mint a jegyeknél. */
    const params = new URLSearchParams({
      tanev: String(this.getAktualisTanevEv()),
      ...this.egysegParamok(),
      tantargy: String(this.kivtantargy),
    });

    this.http.get<any[]>(this.backendApiUrl('/api/szamonkeres-terv/' + this.intezmenyPath()) + '?' + params.toString()).subscribe({
      next: (response) => {
        this.szamonkeresek = Array.isArray(response) ? response : [];
        if (!this.szamonkeresForm.tipus) this.resetSzamonkeresForm();
        if (showLoader) this.data.hideLoading();
      },
      error: (error) => {
        console.error('Számonkérések betöltési hiba:', error);
        if (showLoader) this.data.hideLoading();
        this.data.sendToast('Nem sikerült betölteni a számonkéréseket.', 'error');
      }
    });
  }

  /** Az élő (nem stornózott) bejelentések száma – a fejléc ezt írja ki. */
  get eloSzamonkeresDb(): number {
    return (this.szamonkeresek || []).filter((x: any) => !stornoE(x)).length;
  }

  editSzamonkeres(item: any) {
    this.szamonkeresForm = {
      id: item?.id ?? null,
      datum: item?.datum ?? moment().format('YYYY-MM-DD'),
      tipus: item?.tipus ?? null,
      cim: item?.cim ?? '',
      leiras: item?.leiras ?? ''
    };
  }

  saveSzamonkeres() {
    if (!this.egysegKulcs || !this.kivtantargy) {
      this.data.sendToast('Válassz osztályt vagy csoportot, és tantárgyat.', 'error');
      return;
    }

    if (!this.szamonkeresForm.datum || !String(this.szamonkeresForm.cim || '').trim()) {
      this.data.sendToast('A dátum és a cím megadása kötelező.', 'error');
      return;
    }

    const payload = {
      ...this.szamonkeresForm,
      tanev: this.getAktualisTanevEv(),
      /*  A CSOPORT a tanítási egység, ha az van kiválasztva: így a bejelentést a csoport
       *  tagjai látják, bármelyik osztályba járnak. Az osztály csak akkor megy, ha a
       *  választó egyértelműen adta (egyetlen osztályhoz kötött csoport, vagy osztály). */
      osztaly: this.kivosztaly || null,
      csoport: this.kivcsoport || null,
      tantargy: this.kivtantargy,
      tanar: this.user$?.username || this.user$?.preferred_username || this.user$?.oktazon || null,
    };

    this.szamonkeresMentFolyamatban = true;
    const request = payload.id
      ? this.http.put(this.backendApiUrl('/api/szamonkeres-terv/' + this.intezmenyPath()), payload)
      : this.http.post(this.backendApiUrl('/api/szamonkeres-terv/' + this.intezmenyPath()), payload);

    request.subscribe({
      next: () => {
        this.szamonkeresMentFolyamatban = false;
        this.data.sendToast('Sikeres mentés!', 'success');
        this.resetSzamonkeresForm();
        this.loadSzamonkeresek(false);
      },
      error: (error) => {
        this.szamonkeresMentFolyamatban = false;
        console.error('Számonkérés mentési hiba:', error);
        this.data.sendToast(error?.error?.error || 'Nem sikerült menteni a számonkérést.', 'error');
      }
    });
  }

  /** A bejelentett számonkérés STORNÓZÁSA: a tanári listában áthúzva marad, a diák nem látja. */
  async deleteSzamonkeres(item: any) {
    if (!item?.id || stornoE(item)) return;
    const ok = await stornoOkBekeres(this.alertCtrl, 'számonkérés',
      'A számonkérés nem törlődik: a listában áthúzva megmarad, a diákok és a szülők nem látják többé. Add meg a stornó okát.');
    if (!ok) return;

    this.data.showLoading('Stornózás...');
    this.http.delete(this.backendApiUrl('/api/szamonkeres-terv/' + item.id + '/' + this.intezmenyPath())
      + '?ok=' + encodeURIComponent(ok)).subscribe({
      next: () => {
        this.data.hideLoading();
        this.data.sendToast('A számonkérés stornózva.', 'success');
        if (this.szamonkeresForm.id === item.id) this.resetSzamonkeresForm();
        this.loadSzamonkeresek(false);
      },
      error: (error) => {
        this.data.hideLoading();
        console.error('Számonkérés storno hiba:', error);
        this.data.sendToast(error?.error?.error || 'Nem sikerült stornózni a számonkérést.', 'error');
      }
    });
  }

  /* ── STORNO + ELŐZMÉNY (user, 2026-10-15) ──
   *  A jegyet nem töröljük, hanem stornózzuk: áthúzva megmarad, és sehol nem számít. Az ok
   *  kötelező; a stornózót a kiszolgáló a bejelentkezésből veszi. */
  stornoE = stornoE;
  readonly NAPLO_MUVELET = NAPLO_MUVELET;

  async torolJegy(item) {
    if (!item?.id || stornoE(item)) return;
    const ok = await stornoOkBekeres(this.alertCtrl, 'jegy');
    if (!ok) return;
    await this.data.showLoading("Stornózás...")
    this.http
      .post(this.backendApiUrl('/api/ertekeles/storno'), {
        id: item.id, ok, intezmeny: this.sajatIntezmeny?.intezmenyId,
      })
      .subscribe({
        next: (response) => {
          this.kivalasztottOra?.osztaly_nevsor?.forEach((k: any) => {
            delete k.osztalyzat;
            delete k.szorgalomodost;
          });
          this.data.hideLoading()
          /*  A KRÉTÁ-BAN TÖRLŐDIK: a tétel az Eltérések listára kerül, és a tanár következő
           *  KRÉTA-szinkronja (naplo-kreta-jegyek.js › automataJavitas) ott törli. */
          this.data.sendToast((response as any)?.kreta_figyelmeztetes
            ? 'Stornózva. A jegy a KRÉTÁ-ban is szerepelt – a következő KRÉTA-szinkron ott törli.'
            : 'A jegy stornózva – áthúzva látszik, és nem számít.', 'success')
          this.ertekeles()
        },
        error: (error) => {
          try { this.data.hideLoading() } catch (e) { }
          this.data.sendToast(error?.error?.error || "Nem sikerült stornózni a jegyet.", "error")
        },
      });
  }

  /** Egy tétel előzménye (napló) – `tabla`: tanulo_ertekeles | feljegyzesek | szamonkeres_terv. */
  elozmenyMutat(tabla: string, item: any, cim: string) {
    if (!item?.id) return;
    this.elozmeny = { cim, sorok: [], betolt: true };
    const p = new URLSearchParams({ tabla, id: String(item.id) });
    this.http.get<any[]>(this.backendApiUrl('/api/ertekeles/elozmeny?' + p.toString())).subscribe({
      next: (sorok) => {
        if (!this.elozmeny) return;
        this.elozmeny = { cim, sorok: Array.isArray(sorok) ? sorok : [], betolt: false };
      },
      error: (e) => {
        if (!this.elozmeny) return;
        this.elozmeny = { cim, sorok: [], betolt: false, hiba: e?.error?.error || 'Nem sikerült betölteni az előzményt.' };
      },
    });
  }

  /** Egy napló-érték kiírható alakja (üres → „–”). */
  elozmenyErtek(v: any): string {
    if (v === null || v === undefined || String(v).trim() === '') return '–';
    return String(v);
  }

  feljegyzes() {
    /*  A KÉPERNYŐ A KIVÁLASZTOTT TANÉVET MUTATJA. A táblázatnak egyetlen tanévnyi
     *  oszlopa van (09…06), ezért a lekérdezésnek is a tanév határai közül kell
     *  dolgoznia – enélkül a tavalyi október az idei október cellájába esett, és a
     *  tanévváltás után a régi feljegyzésekkel indult a képernyő. */
    const p = new URLSearchParams(this.egysegParamok());
    if (this.tankezd && this.tanvege) { p.set('tol', this.tankezd); p.set('ig', this.tanvege); }
    this.http
      .get(
        this.backendApiUrl('/api/ertekeles/feljegyzes-osztaly?' + p.toString()),
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          //this.holidays = response
          this.kivalasztottOra = response
          this.ensureFeljegyzesTipusok(response)
          this.data.hideLoading()
          //this.kivalasztottOra.osztalyozasimod = "2"

        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.data.sendToast("Hiba történt", "error")
          this.data.hideLoading()

        },
      });
  }

  private normalizeFeljegyzesTipusok(source: any[]): any[] {
    const mapped = (source || [])
      .map((item: any) => {
        if (typeof item === 'string') return { nev: item };
        const nev = item?.nev || item?.tipus || item?.kategoria || item?.name || null;
        return nev ? { ...item, nev } : null;
      })
      .filter((item: any) => !!item?.nev && String(item.nev).trim());

    const seen = new Set<string>();
    return mapped.filter((item: any) => {
      const key = String(item.nev).trim().toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  private async ensureFeljegyzesTipusok(response?: any): Promise<any[]> {
    if (Array.isArray(this.feljegyzesTipusok) && this.feljegyzesTipusok.length > 0) {
      return this.feljegyzesTipusok;
    }

    return this.fetchFeljegyzesTipusok(response);
  }

  private backendApiUrl(path: string): string {
    const apiOrigin = (environment.apiOrigin || '').replace(/\/api\/?$/, '').replace(/\/$/, '');
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return apiOrigin ? `${apiOrigin}${normalizedPath}` : normalizedPath;
  }

  private intezmenyPath(): string {
    return String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
  }

  private deriveFeljegyzesTipusok(response?: any): any[] {
    const tanulok = response?.[this.egysegKulcs as any]?.feljegyzesek?.tanulok || [];
    const tipusok = new Set<string>();

    (tanulok || []).forEach((tanulo: any) => {
      const months = tanulo?.months || {};
      Object.values(months).forEach((items: any) => {
        (items || []).forEach((item: any) => {
          const tipus = String(item?.tipus || '').trim();
          if (tipus) tipusok.add(tipus);
        });
      });
    });

    return Array.from(tipusok).map(nev => ({ nev }));
  }

  private async fetchFeljegyzesTipusok(fallbackResponse?: any): Promise<any[]> {
    try {
      /*  A PEDAGÓGUS CSAK A NEKI ENGEDETT TÍPUSOKAT LÁTJA. A határozatot, záradékot, törzslapra
       *  kerülő bejegyzést (csak admin típus) admin rögzíti – a kiszolgáló a mentésnél is ellenőriz. */
      const response: any = await firstValueFrom(this.http.get(this.backendApiUrl(
        '/api/feljegyzes/tipusok/lista?intezmeny=' + encodeURIComponent(this.intezmenyPath()))));
      const osszes = this.normalizeFeljegyzesTipusok(Array.isArray(response) ? response : []);
      this.feljegyzesTipusokOsszes = osszes;
      const normalized = osszes.filter((t: any) => t?.rogzitheto !== false);
      const fallback = this.deriveFeljegyzesTipusok(fallbackResponse);
      const tipusok = normalized.length ? normalized : (fallback.length ? fallback : this.alapFeljegyzesTipusok);
      this.feljegyzesTipusok = [...tipusok];
      this.ref.detectChanges();
      return this.feljegyzesTipusok;
    } catch (error) {
      console.error('Feljegyzés típusok betöltési hiba:', error);
      const fallback = this.deriveFeljegyzesTipusok(fallbackResponse);
      const tipusok = fallback.length ? fallback : this.alapFeljegyzesTipusok;
      this.feljegyzesTipusok = [...tipusok];
      this.ref.detectChanges();
      return this.feljegyzesTipusok;
    }
  }

  loadFeljegyzesTipusok(fallbackResponse?: any) {
    this.fetchFeljegyzesTipusok(fallbackResponse);
  }

  private getTanuloBelsoAzonosito(tanulo: any): any {
    return tanulo?.id
      ?? tanulo?.tanulo_id
      ?? tanulo?.tanuloid
      ?? null;
  }

  private getTanuloOktazon(tanulo: any): any {
    return tanulo?.oktazon
      ?? tanulo?.tanulo
      ?? tanulo?.tanulo_oktazon
      ?? tanulo?.tanuloOktazon
      ?? tanulo?.oktAzon
      ?? null;
  }

  /* ═══════ Mezős feljegyzés-típus (backend: feljegyzes-mezok.js) ═══════
   *  A típusnak saját mezői lehetnek (pl. a korlátozott tárgy – mobil – használatának engedélye a
   *  245/2024. Korm. r. 5. § szerint: engedélyező, jogcím, tárgy, cél, időtartam, érintett óra). A
   *  sémát a kiszolgáló adja a típuslistában; a feljegyzés szövegét a kiszolgáló írja a mezőkből,
   *  a szabad szöveg itt csak megjegyzés. */

  /** A kiválasztott típus mezői, vagy null (sima, szöveges típus). */
  feljegyzesMezok(): any[] | null {
    const nev = String(this.feljegyzesForm?.tipus || '').trim().toLowerCase();
    const t = [...(this.feljegyzesTipusokOsszes || []), ...(this.feljegyzesTipusok || [])]
      .find((x: any) => String(x?.nev || '').trim().toLowerCase() === nev);
    return Array.isArray(t?.mezok) && t.mezok.length ? t.mezok : null;
  }

  /** A feltételes mező (`ha`) csak akkor látszik, ha a másik mező értéke illik rá. */
  feljegyzesMezoLatszik(m: any): boolean {
    if (!m?.ha) return true;
    const a = this.feljegyzesForm?.adatok || {};
    return Object.entries(m.ha).every(([k, v]: [string, any]) =>
      (Array.isArray(v) ? v : [v]).includes(String(a[k] ?? '').trim()));
  }

  /** Az engedélyező választható dolgozói (a beíró az alapérték, más név is beírható). */
  get feljegyzesDolgozok(): string[] {
    const nevek = (this.allomany || []).map((a: any) => String(a?.full_name || '').trim()).filter(Boolean);
    return [...new Set(nevek)].sort((x, y) => x.localeCompare(y, 'hu'));
  }

  /** Típusváltáskor a mezős típus alapértékei (engedélyező = a beíró). */
  feljegyzesTipusValtozott() {
    const mezok = this.feljegyzesMezok();
    if (!mezok) return;
    this.feljegyzesForm.adatok = this.feljegyzesForm.adatok || {};
    for (const m of mezok) {
      if (m?.alap === 'beiro' && !String(this.feljegyzesForm.adatok[m.kulcs] || '').trim()) {
        this.feljegyzesForm.adatok[m.kulcs] = this.user$?.name || this.user$?.username || '';
      }
    }
  }

  /** Menthető-e: sima típusnál a szöveg, mezős típusnál a kötelező (látszó) mezők kellenek. */
  feljegyzesMentheto(): boolean {
    const f = this.feljegyzesForm;
    if (!f?.tipus || !f?.datum) return false;
    const mezok = this.feljegyzesMezok();
    if (!mezok) return !!String(f.szoveg || '').trim();
    return mezok.every((m: any) => !m.kotelezo || !this.feljegyzesMezoLatszik(m)
      || !!String(f.adatok?.[m.kulcs] ?? '').trim());
  }

  async ujFeljegyzes(tanulo: any) {
    const tanuloId = this.getTanuloBelsoAzonosito(tanulo);
    const tanuloOktazon = this.getTanuloOktazon(tanulo);

    if (!tanuloId && !tanuloOktazon) {
      this.data.sendToast('A tanuló azonosító nem található.', 'error');
      return;
    }

    const tipusok = await this.ensureFeljegyzesTipusok(this.kivalasztottOra);

    this.aktivFeljegyzesTanulo = tanulo;
    this.feljegyzesForm = {
      id: null,
      tanulo_id: tanuloId,
      tanulo_oktazon: tanuloOktazon,
      datum: moment().format('YYYY-MM-DD'),
      tipus: tipusok?.[0]?.nev || null,
      szoveg: '',
      adatok: {}
    };
    this.feljegyzesTipusValtozott();
    if (!this.feljegyzesModal) {
      this.data.sendToast('A feljegyzés ablak jelenleg nem elérhető.', 'error');
      return;
    }
    this.ref.detectChanges();
    this.feljegyzesModal.present();
  }

  mentFeljegyzes() {
    if ((!this.feljegyzesForm.tanulo_id && !this.feljegyzesForm.tanulo_oktazon) || !this.feljegyzesMentheto()) {
      this.data.sendToast(this.feljegyzesMezok()
        ? 'A dátum, a típus és a csillaggal jelölt mezők kitöltése kötelező.'
        : 'A dátum, típus és szöveg kitöltése kötelező.', 'error');
      return;
    }
    //  Mezős típusnál a mezők mennek; a szöveget a kiszolgáló írja belőlük (a szabad szöveg megjegyzés).
    const mezok = this.feljegyzesMezok();
    const adatok = mezok
      ? { ...(this.feljegyzesForm.adatok || {}), megjegyzes: String(this.feljegyzesForm.szoveg || '').trim() }
      : undefined;

    this.data.showLoading('Feljegyzés mentése...');
    //  Meglévő feljegyzés: módosítás (a KRÉTÁ-ba visszaírandóként jelölve), különben új.
    const modositas = !!this.feljegyzesForm.id;
    const keres = modositas
      ? this.http.put(this.backendApiUrl('/api/feljegyzes/' + this.intezmenyPath() + '/' + this.feljegyzesForm.id), {
        datuma: this.feljegyzesForm.datum,
        szovege: this.feljegyzesForm.szoveg,
        kategoria: this.feljegyzesForm.tipus,
        ...(adatok ? { adatok } : {}),
      })
      : this.http.post(this.backendApiUrl('/api/feljegyzes/' + this.intezmenyPath()), {
        tanulo_id: this.feljegyzesForm.tanulo_id,
        tanulo_oktazon: this.feljegyzesForm.tanulo_oktazon,
        datuma: this.feljegyzesForm.datum,
        szovege: this.feljegyzesForm.szoveg,
        felado: this.user$?.name || this.user$?.username || null,
        kategoria: this.feljegyzesForm.tipus || 'általános',
        ...(adatok ? { adatok } : {}),
      });
    keres.subscribe({
      next: () => {
        this.data.hideLoading();
        this.data.sendToast(modositas ? 'Módosítva.' : 'Sikeres létrehozás!', 'success');
        this.feljegyzesModal.dismiss();
        this.feljegyzes();
      },
      error: (error) => {
        console.error('Feljegyzés mentési hiba:', error);
        this.data.hideLoading();
        const msg = error?.error?.error || 'Hiba történt a mentés során';
        this.data.sendToast(msg, 'error');
      }
    });
  }

  /**
   *  Módosíthatja / törölheti-e a pedagógus ezt a bejegyzést? A csak admin típusú bejegyzést
   *  (határozat, törzslap-bejegyzés) nem – a kiszolgáló is elutasítaná. A megtekintés mindenkié.
   */
  feljegyzesSzerkesztheto(item: any): boolean {
    const nev = String(item?.tipus || '').trim().toLowerCase();
    const t = this.feljegyzesTipusokOsszes.find((x: any) => String(x?.nev || '').trim().toLowerCase() === nev);
    if (t && t.rogzitheto === false) return false;
    //  …és csak a SAJÁT bejegyzését: a kollégáéhoz a kiszolgáló sem engedne hozzányúlni.
    return this.sajatTetel(item);
  }

  async szerkesztFeljegyzes(item: any, tanulo: any) {
    if (!item?.id) { this.data.sendToast('A feljegyzés azonosítója hiányzik.', 'error'); return; }
    await this.ensureFeljegyzesTipusok(this.kivalasztottOra);
    this.aktivFeljegyzesTanulo = tanulo;
    //  Mezős típusnál a tárolt mezők töltődnek vissza, a szöveg mezőbe csak a megjegyzés (a
    //  szöveg többi részét – az összefoglalót – a kiszolgáló mentéskor újraírja).
    let adatok: any = item.adatok;
    if (typeof adatok === 'string') { try { adatok = JSON.parse(adatok); } catch { adatok = null; } }
    adatok = adatok && typeof adatok === 'object' ? { ...adatok } : null;
    this.feljegyzesForm = {
      id: item.id,
      tanulo_id: this.getTanuloBelsoAzonosito(tanulo),
      tanulo_oktazon: this.getTanuloOktazon(tanulo) ?? item.tanulo,
      datum: String(item.created_at || '').slice(0, 10) || moment().format('YYYY-MM-DD'),
      tipus: item.tipus || null,
      szoveg: adatok ? String(adatok.megjegyzes || '') : (item.szoveg || ''),
      adatok: adatok || {}
    };
    //  Ha a tétel típusa (már) nem mezős, a teljes szöveg a szerkeszthető – a régi mezőadatok nem számítanak.
    if (!this.feljegyzesMezok()) { this.feljegyzesForm.szoveg = item.szoveg || ''; this.feljegyzesForm.adatok = {}; }
    this.feljegyzesTipusValtozott();
    //  A régi típus (ha már nem választható) is maradjon a listában, különben üres lenne a mező.
    if (item.tipus && !this.feljegyzesTipusok.some((t: any) => t.nev === item.tipus)) {
      this.feljegyzesTipusok = [...this.feljegyzesTipusok, { nev: item.tipus }];
    }
    if (!this.feljegyzesModal) { this.data.sendToast('A feljegyzés ablak jelenleg nem elérhető.', 'error'); return; }
    this.ref.detectChanges();
    this.feljegyzesModal.present();
  }

  /** A feljegyzés STORNÓZÁSA (nem törlés): áthúzva megmarad, a darabszámba nem számít. */
  async torolFeljegyzes(item: any) {
    const id = item?.id;
    if (!id) {
      this.data.sendToast('A feljegyzés azonosítója hiányzik.', 'error');
      return;
    }
    if (stornoE(item)) return;
    const ok = await stornoOkBekeres(this.alertCtrl, 'feljegyzés');
    if (!ok) return;

    this.data.showLoading('Stornózás...');
    this.http.delete(this.backendApiUrl('/api/feljegyzes/' + this.intezmenyPath() + '/' + id)
      + '?ok=' + encodeURIComponent(ok)).subscribe({
      next: () => {
        this.data.hideLoading();
        this.data.sendToast('A feljegyzés stornózva – áthúzva látszik.', 'success');
        this.feljegyzes();
      },
      error: (error) => {
        console.error('Feljegyzés storno hiba:', error);
        this.data.hideLoading();
        this.data.sendToast(error?.error?.error || 'Hiba történt a stornózás során', 'error');
      }
    });
  }

  /* ═══════ Szülői hiányzás-igazolás ═══════ */

  /** A gyermek hiányzás-adatai: keret, napok, beadott igazolások. */
  hi: any = null;
  hiKijelolt: { [datum: string]: boolean } = {};
  hiIndoklas = '';
  hiFolyamatban = false;

  /** Csak azok a napok, ahol van igazolásra váró óra és még nincs beadott kérés. */
  /** A tanuló saját belépése: csak nézet, igazolás beadása nélkül. */
  tanuloNezet = false;

  get hiIgazolando(): any[] {
    return (this.hi?.napok || []).filter((n: any) => n.igazolhato);
  }

  /*  AZ IGAZOLÁS FAJTÁJA. A szülői keretből csak a szülő saját igazolása fogy; az orvosi
   *  és a hivatalos igazolást (pl. nyelvvizsga) az osztályfőnök bírálja el a feltöltött
   *  dokumentum alapján – ezért ott a melléklet kötelező. Az érték a `mulasztas_tipus` id. */
  private readonly hiAlapTipusok = [
    { id: 2, nev: 'Szülői igazolás (a keretből)' },
    { id: 1, nev: 'Orvosi igazolás (nem a keretből)' },
    { id: 4, nev: 'Hivatalos igazolás – pl. nyelvvizsga, hatósági ügy (nem a keretből)' },
  ];
  /*  PÁLYAVÁLASZTÁSI CÉLÚ TÁVOLLÉT (7) – 20/2012. EMMI r. 51. § (2) e): a 7–8. és a 10–12.
   *  évfolyamos tanuló tanévenként legfeljebb két alkalommal, a szervező intézmény igazolásával.
   *  Csak a jogosult évfolyamon kínáljuk; a keretet a kiszolgáló adja (`palyavalasztas`), és a
   *  túllépést ő is elutasítja – itt csak előre jelezzük. */
  static readonly PALYAVALASZTASI_TIPUS = 7;
  private hiTipusokForras: any = null;
  private hiTipusokCache: { id: number, nev: string }[] = [];
  get hiTipusok(): { id: number, nev: string }[] {
    if (this.hiTipusokForras === this.hi) return this.hiTipusokCache;
    const pv = this.hi?.palyavalasztas;
    this.hiTipusokForras = this.hi;
    this.hiTipusokCache = pv?.jogosult
      ? [...this.hiAlapTipusok, { id: ErtekelesekComponent.PALYAVALASZTASI_TIPUS,
          nev: `Pályaválasztási célú távollét – nyílt nap, pályaorientációs rendezvény (tanévente ${pv.keret} alkalom, nem a szülői keretből)` }]
      : this.hiAlapTipusok;
    return this.hiTipusokCache;
  }
  hiTipus = 2;

  get hiPalyavalasztas(): boolean {
    return Number(this.hiTipus) === ErtekelesekComponent.PALYAVALASZTASI_TIPUS;
  }

  /** A kijelölt napok közül hány lépné túl a pályaválasztási keretet (0, ha nem az a típus). */
  get hiPalyaTullepes(): number {
    if (!this.hiPalyavalasztas) return 0;
    const maradek = Number(this.hi?.palyavalasztas?.maradek ?? 0);
    return Math.max(0, this.hiKijeloltDb - maradek);
  }

  get hiDokumentumos(): boolean {
    return Number(this.hiTipus) !== 2;
  }

  /*  NAP, AMELYEN MÉG NINCS RÖGZÍTETT HIÁNYZÁS. A tanár gyakran később pótolja a naplót –
   *  a szülő viszont akkor adná be az igazolást, amikor a papír a kezében van. Eddig
   *  ilyenkor a teljes beadó rész el sem jelent meg („minden inaktív"). */
  hiKeziDatum = '';
  hiKeziNapok: string[] = [];

  /** A mai nap (helyi idő szerint) – ennél későbbi napra nincs igazolás. */
  get hiMa(): string {
    const d = new Date();
    const p = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
  }

  get hiVanBeadhato(): boolean {
    return this.hiIgazolando.length > 0 || this.hiKeziNapok.length > 0;
  }

  hiKeziHozzaad() {
    const d = String(this.hiKeziDatum || '').slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(d)) { this.data.sendToast('Válassz egy napot.', 'warning'); return; }
    if ((this.hi?.tanev_kezd && d < this.hi.tanev_kezd) || (this.hi?.tanev_vege && d > this.hi.tanev_vege)) {
      this.data.sendToast('Ez a nap nem ebbe a tanévbe esik.', 'warning'); return;
    }
    if (d > this.hiMa) { this.data.sendToast('Jövőbeli napra még nem adható be igazolás.', 'warning'); return; }
    if ((this.hi?.igazolasok || []).some((i: any) => i.datum === d)) {
      this.data.sendToast('Erre a napra már van beadott igazolás – lent, a beadottak között látod.', 'warning');
      return;
    }
    const nap = (this.hi?.napok || []).find((n: any) => n.datum === d);
    if (nap && !nap.igazolhato) {
      this.data.sendToast('Ennek a napnak már minden hiányzása rendezett.', 'warning'); return;
    }
    //  Ha a nap már a listában van (rögzített hiányzás), elég kijelölni.
    if (!nap && !this.hiKeziNapok.includes(d)) this.hiKeziNapok = [...this.hiKeziNapok, d].sort().reverse();
    this.hiKijelolt[d] = true;
    this.hiKeziDatum = '';
  }

  hiKeziTorol(d: string) {
    this.hiKeziNapok = this.hiKeziNapok.filter((x) => x !== d);
    delete this.hiKijelolt[d];
  }

  /** A beadott igazolás állapotának emberi neve. */
  /*  A beküldött melléklet megnyitása a gondviselőnek. A fájl a belépési jeggyel
   *  töltődik le – a sima link nem vinné a jegyet, és a kiszolgáló nem adná ki. */
  hiCsatolmanyNyit(c: any) {
    if (!c?.id) return;
    this.data.megnyitFajl(
      `/api/hianyzas-igazolas/csatolmany-fajl/${c.id}/${this.intezmenyPath()}`,
      c.nev || 'Melléklet');
  }

  hiAllapot(i: any): string {
    if (i?.statusz === 'igazolt') return 'Igazolva';
    if (i?.statusz === 'elutasitva') return 'Elutasítva';
    //  Az osztályfőnök tévesnek találta és visszavonta a nap elbírálását: a nap
    //  visszakerült a keretbe, és újra beadható.
    if (i?.statusz === 'visszavonva') return 'Visszavonva – újra beadható';
    if (i?.statusz === 'elbiralasra_var') return 'Osztályfőnöki elbírálásra vár';
    return 'Igazgatói engedélyre vár';
  }

  get hiKijeloltDb(): number {
    return Object.keys(this.hiKijelolt).filter((d) => this.hiKijelolt[d]).length;
  }

  /** Egy nap tantárgyai felsorolva (a listában ez adja a kontextust). */
  hiTantargyak(nap: any): string {
    const nevek = [...new Set((nap?.orak || []).map((o: any) => o.tantargy).filter(Boolean))];
    return nevek.join(', ');
  }

  /*  EGY HIÁNYZOTT ÓRA ÁLLAPOTÁNAK SZÍNE az „Összes hiányzás" listában és az összesítőben.
   *  A típus NEVÉT a kiszolgáló adja (`tipus_nev`) – itt csak a szín dől el a kódból:
   *  ≤ -2 igazolatlan, -1 még igazolandó, pozitív = valamilyen igazolás. */
  hiOraSzin(tipus: any): string {
    const t = Number(tipus);
    if (t <= -2) return 'danger';
    if (t === -1) return 'warning';
    return t > 0 ? 'success' : 'medium';
  }

  /**
   *  A gondviselői nézet betöltése. A régi n8n webhook helyett a saját végpont:
   *  a hiányzások az órarend `hianyzo`/`igazolas` mezőiből épülnek, a keret pedig
   *  intézményi beállítás.
   */
  gondviselo(){
    if (!this.kivtanulo) return;
    const intezmeny = this.intezmenyPath();
    this.http
      .get<any>(`/api/hianyzas-igazolas/tanulo/${this.kivtanulo}/${intezmeny}`)
      .subscribe({
        next: (response) => {
          this.hi = response;
          this.hiKijelolt = {};
          this.hiIndoklas = '';
          this.hiKeziNapok = [];
          this.hiKeziDatum = '';
          this.hiTipus = 2;
          this.kesesBetolt();
          this.data.hideLoading();
        },
        error: (error) => {
          this.data.hideLoading();
          console.error('Hiányzás-adatok betöltése sikertelen:', error);
          this.data.sendToast(error?.error?.error || 'Nem sikerült betölteni a hiányzásokat.', 'error');
        },
      });
  }

  /* ══════════════════════════════════════════════════════════════════════
   *  KÉSÉSEK a gondviselői hiányzás-nézetben.
   *
   *  A késés és a hiányzás ugyanannak a kérdésnek a két fele – a jogszabály szerint
   *  45 összegyűlt igazolatlan késés-perc egy igazolatlan órának minősül –, ezért
   *  EGY képernyőn mutatjuk. Amit itt látni kell: mennyi gyűlt össze, ebből hány óra
   *  lett, és mennyi hiányzik a következőig.
   * ═════════════════════════════════════════════════════════════════════ */

  keses: any = null;

  kesesBetolt() {
    this.keses = null;
    if (!this.kivtanulo) return;
    this.http
      .get<any>(`/api/keses/tanulo/${this.kivtanulo}/${this.intezmenyPath()}`)
      .subscribe({
        next: (r) => { this.keses = r; },
        // A késés kiegészítő információ: ha nem jön meg, a hiányzás-nézet ettől még használható.
        error: () => { this.keses = null; },
      });
  }

  /**
   *  A kijelölt napok igazolása. A kereten belüli napok azonnal igazolódnak,
   *  a kereten felüliek igazgatói engedélyre várnak – ezt a válasz vissza is jelzi.
   */
  /*  CSATOLMÁNY – OPCIONÁLIS.
   *
   *  Az igazolás magától szöveges. Ahol az iskola papírt kér (orvosi igazolás, szülői
   *  levél), ott a fényképe ide csatolható – de sehol nem feltétel: aki nem tölt fel
   *  semmit, ugyanúgy be tudja adni. A fájl a beadás UTÁN megy fel, mert csak akkor
   *  van mihez kötni. */
  hiFajl: File | null = null;

  hiFajlValaszt(esemeny: any) {
    const f = esemeny?.target?.files?.[0] || null;
    if (f && f.size > 15 * 1024 * 1024) {
      this.data.sendToast('A fájl túl nagy (legfeljebb 15 MB).', 'warning');
      return;
    }
    this.hiFajl = f;
  }

  /*  A LEGUTÓBBI BEADÁS azonosítói – hogy a melléklet PÓTOLHATÓ legyen, ha elsőre
   *  nem ment fel. Enélkül a szülő zsákutcába kerül: az igazolás beadva, a nap
   *  levonva a keretből, a papír meg sehol. */
  hiUtolsoIdk: string[] = [];
  hiUtolsoKeretbol = true;

  private async hiCsatolmanytFeltolt(igazolasIds: string[], keretbol = true) {
    if (!this.hiFajl || !igazolasIds.length) return;
    let siker = 0;
    let utolsoHiba = '';
    for (const id of igazolasIds) {
      //  MINDEN naphoz SAJÁT FormData: ugyanaz a példány a második POST-nál már
      //  elhasznált adatfolyamot vinne, és a feltöltés némán elbukna.
      const adat = new FormData();
      adat.append('file', this.hiFajl);
      try {
        await firstValueFrom(this.http.post(
          `/api/hianyzas-igazolas/csatolmany/${id}/${this.intezmenyPath()}`, adat));
        siker += 1;
      } catch (e: any) { utolsoHiba = e?.error?.error || e?.message || ''; }
    }
    if (siker === igazolasIds.length) {
      this.data.sendToast(`A melléklet feltöltve (${siker} naphoz).`, 'success');
      this.hiFajl = null;
      this.hiUtolsoIdk = [];
      return;
    }
    /*  A FÉLIGAZSÁG ITT A LEGROSSZABB. Az igazolás MEGVAN és a nap MÁR LEVONÓDOTT a
     *  keretből – csak a melléklet nem ment fel. Ha ezt nem mondjuk ki, a szülő azt
     *  hiszi, az egész beadás sikertelen volt, és újra próbálja (amit a rendszer már
     *  nem enged, mert arra a napra van kérés). */
    this.hiUtolsoIdk = igazolasIds;
    //  Az orvosi/hivatalos igazolás nem a keretből megy – ott azt kell kimondani, hogy
    //  papír nélkül az osztályfőnök nem tudja elbírálni.
    this.data.sendToast(
      (keretbol
        ? `Az igazolás BEADVA és a nap már levonódott a keretből – csak a melléklet nem ment fel`
        : `Az igazolás BEADVA, de a melléklet nem ment fel – nélküle az osztályfőnök nem tudja elbírálni`)
      + `${siker ? ` (${siker}/${igazolasIds.length} sikerült)` : ''}.`
      + ` A „Melléklet pótlása" gombbal újrapróbálható.${utolsoHiba ? ' (' + utolsoHiba + ')' : ''}`,
      'warning');
  }

  /** A melléklet pótlása a legutóbb beadott igazolás(ok)hoz. */
  async hiMellekletPotlas() {
    if (!this.hiFajl || !this.hiUtolsoIdk.length) return;
    this.hiFolyamatban = true;
    try { await this.hiCsatolmanytFeltolt(this.hiUtolsoIdk, this.hiUtolsoKeretbol); this.gondviselo(); }
    finally { this.hiFolyamatban = false; }
  }

  /*  MELLÉKLET UTÓLAG, a beadott igazolások listájából. A papír gyakran később kerül
   *  elő (az orvosi igazolást másnap hozzák) – az igazolás viszont már beadva. */
  hiPotloIgazolas: any = null;

  hiPotloValaszt(igazolas: any) {
    this.hiPotloIgazolas = igazolas;
    const be = document.getElementById('hi-potlo-fajl') as HTMLInputElement | null;
    if (be) { be.value = ''; be.click(); }
  }

  async hiPotloFajl(esemeny: any) {
    const f = esemeny?.target?.files?.[0] || null;
    const cel = this.hiPotloIgazolas;
    this.hiPotloIgazolas = null;
    if (!f || !cel?.id) return;
    if (f.size > 15 * 1024 * 1024) { this.data.sendToast('A fájl túl nagy (legfeljebb 15 MB).', 'warning'); return; }
    const adat = new FormData();
    adat.append('file', f);
    this.hiFolyamatban = true;
    try {
      await firstValueFrom(this.http.post(
        `/api/hianyzas-igazolas/csatolmany/${cel.id}/${this.intezmenyPath()}`, adat));
      this.data.sendToast('A melléklet feltöltve.', 'success');
      this.gondviselo();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A melléklet feltöltése nem sikerült.', 'error');
    } finally { this.hiFolyamatban = false; }
  }

  hiIgazol() {
    const napok = Object.keys(this.hiKijelolt).filter((d) => this.hiKijelolt[d]);
    if (!napok.length) { this.data.sendToast('Jelölj ki legalább egy napot.', 'warning'); return; }
    const tipus = Number(this.hiTipus) || 2;
    const dokumentumos = tipus !== 2;
    //  Orvosi / hivatalos igazolást papír nélkül nincs miből elbírálni.
    if (dokumentumos && !this.hiFajl) {
      this.data.sendToast(this.hiPalyavalasztas
        ? 'A pályaválasztási célú távolléthez csatold a szervező intézmény igazolását (fénykép vagy PDF).'
        : 'Orvosi vagy hivatalos igazoláshoz csatold a dokumentumot (fénykép vagy PDF).', 'warning');
      return;
    }
    if (this.hiPalyaTullepes > 0) {
      this.data.sendToast(`Pályaválasztási célú távollét tanévente legfeljebb ${this.hi?.palyavalasztas?.keret ?? 2} alkalommal `
        + `igazolható – ebből ${this.hi?.palyavalasztas?.maradek ?? 0} maradt. Kevesebb napot jelölj ki, vagy válassz más fajtát.`, 'warning');
      return;
    }

    this.hiFolyamatban = true;
    this.http
      .post<any>(`/api/hianyzas-igazolas/igazolas/${this.kivtanulo}/${this.intezmenyPath()}`, {
        napok,
        tipus,
        indoklas: this.hiIndoklas,
        igenylo: this.user$?.username || null,
      })
      .subscribe({
        next: async (r) => {
          this.hiFolyamatban = false;
          const reszek = [];
          if (r.igazolt?.length) reszek.push(`${r.igazolt.length} nap igazolva`);
          if (r.engedelyre_var?.length) reszek.push(`${r.engedelyre_var.length} nap igazgatói engedélyre vár`);
          if (r.elbiralasra_var?.length) reszek.push(`${r.elbiralasra_var.length} nap az osztályfőnök elbírálására vár`);
          if (r.kihagyva?.length) reszek.push(`${r.kihagyva.length} nap kimaradt (már van rá igazolás, vagy nem ebbe a tanévbe esik)`);
          this.data.sendToast(reszek.join(', ') || 'Nem történt változás.',
            r.engedelyre_var?.length || r.kihagyva?.length ? 'warning' : 'success');
          //  A melléklet a létrejött igazolás(ok)hoz kerül – a kiszolgáló adja vissza az
          //  azonosítókat; ha nem, a feltöltés kimarad, de az igazolás megvan.
          const idk = [...(r.igazolt || []), ...(r.engedelyre_var || []), ...(r.elbiralasra_var || [])]
            .map((x: any) => (typeof x === 'string' ? x : x?.id)).filter(Boolean);
          this.hiUtolsoKeretbol = !dokumentumos;
          await this.hiCsatolmanytFeltolt(idk, !dokumentumos);
          this.gondviselo();
        },
        error: (e) => {
          this.hiFolyamatban = false;
          this.data.sendToast(e?.error?.error || 'Az igazolás nem sikerült.', 'error');
        },
      });
  }
  igazol(){
    this.data.showLoading("Egy pillanat...")
    this.data.hideLoading()
  }



  /*  Mi hiányzik ahhoz, hogy betöltsön? Enélkül a képernyő némán nem csinál semmit,
   *  és a felhasználó azt hiszi, elromlott. */
  get miHianyzik(): string {
    if (['1', '5', '6'].includes(String(this.uzemmod))) {
      if (!this.egysegKulcs) return 'Válassz osztályt vagy csoportot.';
      if (!this.kivtantargy) return 'Válassz tantárgyat is — enélkül nincs mit betölteni.';
      /*  A számonkérés-terv CSOPORTRA is szól. Korábban itt osztályt követeltünk, és a
       *  több osztályt átfogó csoportnál (nyelvi, fakultációs) a kolléga hiába választotta
       *  ki a csoportját, a képernyő „válassz osztályt"-tal megállt (europa2000,
       *  2026-09-15). A csoport önálló tanítási egység, mint a jegyeknél. */
    }
    if (String(this.uzemmod) === '2') {
      if (!this.egysegKulcs) return 'Válassz osztályt vagy csoportot.';
      /*  A HETI MULASZTÁS-NÉZET OSZTÁLYRA SZÓL. Több osztályt átfogó csoportnál nincs
       *  egyetlen osztály, amire a hét kiírható volna – ezt mondjuk is ki, mert egy
       *  néma, üres képernyő azt a látszatot kelti, hogy elromlott. A csoportos óra
       *  hiányzásai a naplóban, óránként vezethetők. */
      if (!this.kivosztaly) {
        return 'Ez a nézet osztályra szól. A választott csoport több osztályt fog át — '
          + 'válassz osztályt, a csoport hiányzásait pedig a naplóban, óránként vezesd.';
      }
      if (!this.kivdatum) return 'Válassz hetet is.';
    }
    if (String(this.uzemmod) === '3' && !this.egysegKulcs) return 'Válassz osztályt vagy csoportot.';
    if (String(this.uzemmod) === '4' && !this.kivtanulo) return 'Válassz tanulót.';
    return '';
  }

  async kivalaszt(mit, e) {
    this.kivalasztottOra = null
    if (mit == "osztaly") {
      /*  A tétel osztályt ÉS csoportot is hordozhat. A csoportnál az `id` a csoport
       *  osztálya, DE csak akkor, ha a csoport egyetlen osztályhoz kötődik – a
       *  többségük többhöz, ott `null`. Ezért nem az osztály, hanem a CSOPORT a kulcs;
       *  a névsort a tagsága adja. */
      /*  NEM `e?.id ?? e`: a több osztályt átfogó csoportnál az `id` null, és a `??`
       *  ilyenkor az EGÉSZ tételt tette az osztály helyére. A mentés így „[object Object]”
       *  osztályt küldött, a jegy nem ment be (europa2000, 10/fg/3/angol, 2026-09-14). */
      this.kivosztaly = e && typeof e === 'object' ? (e.id ?? null) : (e ?? null)
      this.kivcsoport = e?.csoport ?? null
      this.kivEgyseg = e && typeof e === 'object' ? e : null
      this.mindenTantargy = false
      //  Ha az előző tantárgy itt nem tanított tárgy, ne maradjon kiválasztva észrevétlenül.
      const itteni = ((this.kivEgyseg?.tantargyak || []) as any[]).map(String)
      if (itteni.length && this.kivtantargy && !itteni.includes(String(this.kivtantargy)) && !e?.tantargy
          && !this.orarendFuggetlenTantargy(this.kivtantargy)) {
        this.kivtantargy = null
        this.kivtantargyNev = null
      }
      this.csoportTanulok = []
      /*  MEGVÁRJUK a névsort. Eddig a betöltés elindulhatott előbb, mint ahogy a
       *  csoport tanulói megjöttek – olyankor a szűrés üres névsort adott, és a
       *  képernyő úgy nézett ki, mintha a csoportban senki nem lenne. */
      if (this.kivcsoport) await this.csoportTanulokBetoltese(this.kivcsoport)
      /*  A CSOPORT TANTÁRGYA magától beáll: egy bontott csoporthoz jellemzően egy
       *  tantárgy tartozik, a betöltés viszont osztály ÉS tantárgy nélkül el sem indul –
       *  csoportot választva eddig „nem történt semmi". A kiszolgáló csak egyértelmű
       *  esetben ad javaslatot; ahol nincs, ott a mező érintetlen marad. */
      if (e?.tantargy && !this.orarendFuggetlenTantargy(this.kivtantargy)) {
        this.kivtantargy = e.tantargy
        const t = (this.tantargy || []).find((x: any) => String(x.id) === String(e.tantargy))
        this.kivtantargyNev = t?.name ?? t?.nev ?? null
      }
      this.tantargyValasztekFrissit()
    }
    if (mit == "tanar") { this.kivtanar = e?.adid ?? e }
    if (mit == "tantargy") {
      this.kivtantargy = e?.id ?? e
      const selectedTantargy = (this.tantargy || []).find((t: any) => t.id === this.kivtantargy)
      this.kivtantargyNev = e?.name ?? selectedTantargy?.name ?? selectedTantargy?.nev ?? null  // tantargyak keyed by name in n8n response
      // Másik tantárgynál a mód a TANTÁRGY alapértéke legyen, ne az előzőé:
      // a magatartás/szorgalom fokozatos, a többi alapból 1-5.
      if (this.kivalasztottOra) this.kivalasztottOra.osztalyozasimod = null
    }
    if (mit == "tanulo") { this.kivtanulo = e?.oktazon ?? e }
    if (mit == "datum") {
      this.kivdatum = e.target.value
      this.kivdatummin = moment(e.target.valueAsDate).format("YYYY-MM-DD")
      this.kivdatummax = moment(e.target.valueAsDate).add('5', 'days').format("YYYY-MM-DD")
    }
    if (this.egysegKulcs && this.kivtantargy && (this.uzemmod == "1" || this.uzemmod == "5")) {
      this.data.showLoading("Egy pillanat...")
      this.ertekeles()
    } else if (this.egysegKulcs && this.kivtantargy && this.uzemmod == "6") {
      this.loadSzamonkeresek()
    } else if (this.kivosztaly && this.kivdatum && this.uzemmod == "2") {
      this.data.showLoading("Egy pillanat...")
      this.mulasztas()
    } else if (this.egysegKulcs && this.uzemmod == "3") {
      this.data.showLoading("Egy pillanat...")
      this.feljegyzes()
    } else if (this.kivtanulo && this.uzemmod == "4") {
      this.data.showLoading("Egy pillanat...")
      this.gondviselo()
    }
  }

  /** A választott csoport tanulói – ebből szűkül a névsor. */
  private async csoportTanulokBetoltese(csoport: string) {
    try {
      const r: any = await firstValueFrom(this.http.get(
        `/api/tanitott/csoport/${csoport}/tanulok/${this.sajatIntezmeny.intezmenyId}`));
      this.csoportTanulok = (r?.oktazonok || []).map((x: any) => String(x));
      /*  ÜRES CSOPORT = ÜRES NÉVSOR. Eddig üres listánál elejtettük a csoportot, és az
       *  egész osztály névsora jött be (egy 1–2 fős fejlesztő csoportnál a fél évfolyam).
       *  2026-09-28 (user): ne legyen ilyen – a csoport marad kiválasztva, üresen. */
    } catch (e) {
      this.csoportTanulok = [];
    }
    this.ref.detectChanges();
  }

  async init() {
    this.isSlotFilled = [];
    this.cardInSlot = [];
    this.ttf = [];
    this.slots = [];
    this.cards = [];
    this.filled = [];
    this.elhasznalt = [];
    this.sajatIntezmeny = await this.data.getFromStorage("sajatIntezmeny");
    this.jegyBeallitasBetolt(this.http, this.sajatIntezmeny?.intezmenyId);
    // Itt a lista NÉVFELOLDÁSRA is kell (a korábbi értékelések tanárához), ezért a
    // kilépett kollégák is kellenek – különben a régi rekordokon eltűnne a nevük.
    this.allomany = await this.data.getAllomany(this.sajatIntezmeny.intezmenyId, true).toPromise();
    await this.oauth.loadUserProfile();
      this.user$ = this.data.belepoKilet(this.oauth.getIdentityClaims());


      /*  TANULÓI NÉZET. A diák a saját hiányzásait és késéseit látja, de igazolást nem ad
       *  be: a szülői keret a gondviselőé, és a kiszolgáló is csak tőle fogadja el. */
      this.tanuloNezet = String(await this.data.getFromStorage("loginmode") || '') === 'tanulo';
      if (this.uzemmod == "4") this.tanulok(await this.data.getFromStorage("sajatIntezmeny"))
    /*this.allomany.forEach(a => {
      this.allomany[a.adid] = a
      this.allomany[a.adid].intezmenyadatok = JSON.parse(this.allomany[a.adid].intezmenyadatok)[0]
    })*/

    // A MEGJELENÍTETT tanév a fejléc tanév-választójából jön (munkatanév), nem az
    // intézmény aktuális tanévéből. Enélkül a korábbi tanévre visszaváltva is az ÚJ
    // osztályok jelentek meg, üres névsorral és jegyek nélkül.
    this.megjelenitettTanev = await this.data.getMunkatanev();
    this.aktualisTanev = await this.data.getAktualisTanev();
    const tanevadatok = JSON.parse(await this.data.getFromStorage("tanevadatok")) || [];
    let tanev = tanevadatok.filter(d => d.id == this.megjelenitettTanev)[0]
      || tanevadatok.filter(d => d.id == this.aktualisTanev)[0];
    this.tankezd = moment(tanev.tankezd).format("YYYY-MM-DD")
    this.tanfelev = moment(tanev.felev).format("YYYY-MM-DD")

    const ev = moment(tanev.tankezd).format("YYYY");
    /*  A VÁLASZTÓ TARTALMA A KISZOLGÁLÓTÓL JÖN.
     *
     *  Eddig az intézmény ÖSSZES osztálya jelent meg, csoport pedig egyáltalán nem: a
     *  pedagógus nyolcvan osztály közül kereste ki azt a kettőt, amit tanít, a bontott
     *  csoportjai viszont sehol nem szerepeltek – pedig az órái nagy része ott van.
     *  A szűrés a kiszolgálón történik: ami nem az övé, azt meg sem kapja. */
    try {
      const t: any = await firstValueFrom(this.http.get(
        `/api/tanitott/${this.sajatIntezmeny.intezmenyId}?ev=${ev}`));
      this.tanitottAdmin = !!t?.admin;
      this.egysegbenTantargyIdk = ((t?.egysegben_tantargyak || []) as any[]).map(String);
      this.tanitottLista = this.filterVisibleOsztalyok(t?.tetelek || []);
      this.osztalyValasztekFrissit();
    } catch (e) {
      /*  Ha a lekérés elszáll, a régi viselkedés a tartalék: inkább lássa az összes
       *  osztályt, mint egy üres választót. */
      this.tanitottAdmin = false;
      this.osztaly = this.filterVisibleOsztalyok(
        await this.data.getOsztaly(ev, this.sajatIntezmeny.intezmenyId).toPromise()
      ).map((o: any) => ({ ...o, ertek: `o:${o.id}`, nev: o.osztaly, tipus: 'osztaly' }));
    }
    this.terem = await this.data.getTanterem(ev, this.sajatIntezmeny.intezmenyId).toPromise();
    this.tantargy = await this.data.getTantargy(ev, this.sajatIntezmeny.intezmenyId).toPromise();
    this.tantargyValasztekFrissit();

    this.tanvege = moment(tanev.tanvege).format("YYYY-MM-DD")
    this.loadErtekelesTipusok();
    this.resetSzamonkeresForm();

    let umd = await this.data.getFromStorage("userMetadata")



  }

  ttModal(ok, id, i) {
    if (!ok) return
    this.kivalasztottora = this.cardInSlot[id][i]
    this.modal.present();
  }
  onWillDismiss(e) {

  }
  confirm() {
    //this.loader.present();
    //this.showLoading('Mentés...');
    this.modal.dismiss(null, 'confirm');
  }
  cancel() {
    this.modal.dismiss(null, 'cancel');
  }
  validateForm() {
    return false;
  }
  delOrarend() {

  }




}
